import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, Component, Input, Output, ɵɵInheritDefinitionFeature, ɵɵprojectionDef, ɵɵelementStart, ɵɵlistener, ɵɵelementEnd, ɵɵelement, ɵɵprojection, ɵɵclassMapInterpolate1, ɵɵadvance, ɵɵattribute, ɵɵproperty, ɵɵpureFunction3, ɵɵgetInheritedFactory, ɵɵtext, ɵɵnextContext, ɵɵtextInterpolate, ɵɵtemplate, ɵɵpropertyInterpolate, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵpureFunction1, ɵɵtextInterpolate1, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵpureFunction2, ɵɵcontentQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵclassProp, ContentChild, ɵɵviewQuery, ViewChild, ɵɵinject, Inject, ɵɵdefinePipe, Pipe, ɵɵpipe, ɵɵpipeBind1, ɵɵsanitizeHtml, ɵɵstyleProp, ɵɵsanitizeUrl, ɵɵpureFunction0, ElementRef, ɵɵdefineDirective, ɵɵresolveDocument, Directive, HostListener, Injector, ɵɵNgOnChangesFeature, ɵɵtemplateRefExtractor, ɵɵelementContainer, ɵɵstaticViewQuery, TemplateRef, ContentChildren, ɵɵreference, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { v4 } from 'uuid';
import { CheckboxControlValueAccessor, NgControlStatus, FormControlDirective, DefaultValueAccessor, NgModel, RadioControlValueAccessor, MaxLengthValidator, NumberValueAccessor, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass, NgIf, NgForOf, Location, NgStyle, NgTemplateOutlet, CommonModule } from '@angular/common';
import { BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HttpClient, HttpErrorResponse, HttpClientModule } from '@angular/common/http';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { mergeMap, catchError, finalize, map } from 'rxjs/operators';
import { of, throwError, from, ReplaySubject, timer } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CookieService } from 'ngx-cookie-service';
import * as moment_ from 'moment';
import { NavigationStart, Router } from '@angular/router';
import checkIsPwa from 'check-is-pwa';
import { DomSanitizer } from '@angular/platform-browser';
import { SwiperComponent, SwiperSlideDirective, SwiperModule } from 'swiper/angular';
import SwiperCore, { Pagination } from 'swiper/core';
import { NgSelectComponent, ɵf, NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightDirective, NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import { BsLocaleService, BsDatepickerInlineDirective, BsDatepickerInputDirective, BsDatepickerDirective, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ToastrService } from 'ngx-toastr';
import { AccordionComponent, AccordionPanelComponent, AccordionModule } from 'ngx-bootstrap/accordion';

class AmdocsFunctionsService {
    constructor() {
    }
    createGuid() {
        return v4();
    }
    convertArrayForQueryString(obj, prefix) {
        const arr = [];
        let p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                const k = prefix ? prefix + '[' + p + ']' : p;
                const v = obj[p];
                arr.push((v !== null && typeof v === 'object') ?
                    this.convertArrayForQueryString(v, k) :
                    encodeURIComponent(k) + '=' + encodeURIComponent(v));
            }
        }
        return arr;
    }
    sortArrayByKey(arr, key, asc = true) {
        if (asc) {
            arr.sort((a, b) => {
                return ((a[key] > b[key]) ? -1 : ((a[key] < b[key]) ? 1 : 0));
            });
        }
        else {
            arr.sort((a, b) => {
                return ((a[key] < b[key]) ? -1 : ((a[key] > b[key]) ? 1 : 0));
            });
        }
        return arr;
    }
    createValueKeyArray(max) {
        const array = [];
        for (let i = 1; i <= max; i++) {
            array.push({ key: i, value: i });
        }
        return array;
    }
    /**
     * clear array from a certain value
     * @param arr - array of any
     * @param clearVal - value to clear
     * @returns any[]
     */
    clearArray(arr, clearVal = null) {
        const tmpArr = [];
        arr.forEach((tmpItem) => {
            if (tmpItem !== clearVal) {
                tmpArr.push(tmpItem);
            }
        });
        return tmpArr;
    }
    getUrlParamByName(name, url = null) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    getErrorMsg(formControl, errors) {
        if (formControl.errors && errors) {
            for (let errorKey in formControl.errors) {
                if (errors[errorKey]) {
                    return errors[errorKey];
                }
            }
        }
        return null;
    }
    navigateExternalUrl(path, target = '_blank') {
        window.open(path, target);
    }
    cloneObj(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
}
AmdocsFunctionsService.ɵfac = function AmdocsFunctionsService_Factory(t) { return new (t || AmdocsFunctionsService)(); };
AmdocsFunctionsService.ɵprov = ɵɵdefineInjectable({ token: AmdocsFunctionsService, factory: AmdocsFunctionsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsFunctionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AmdocsControlAbstract {
    /**
     * Instantiate a form control instance if not provided
     */
    constructor(amdocsFunctionsService) {
        this.amdocsFunctionsService = amdocsFunctionsService;
        /**
         * Wrapper custom class - optional
         */
        this.customClass = '';
        this.inputPipe = null;
        this.placeHolder = '';
        this.readOnly = false;
        this.inputMaxLength = null;
        this.inputMode = 'text';
        this.textCenter = false;
        this.hideLabel = false;
        this.showValidationErrorText = true;
        this.onChangedCallback = new EventEmitter();
        this.focusCallback = new EventEmitter();
        this.blurCallback = new EventEmitter();
        this.keyDownCallback = new EventEmitter();
        this.keyUpCallback = new EventEmitter();
        /**
         * Will change on blur
         */
        this.handleErrorValidation = true;
        this.isFocused = false;
    }
    ngOnInit() {
        if (!this.control) {
            throw new Error('Attribute \'control\' is required');
        }
        if (!this.elementId) {
            throw new Error('Attribute \'elementId\' is required');
        }
    }
    /**
     * return true if the form control is disabled
     */
    isDisabled() {
        return this.control ? this.control.disabled : null;
    }
    /**
     * emit an Output function on change
     */
    onChange() {
        if (this.onChangedCallback.observers.length) {
            this.onChangedCallback.emit(this.control);
        }
    }
    /**
     * emit an Output function on change
     */
    onFocus($event = null) {
        this.isFocused = true;
        if (this.focusCallback.observers.length) {
            this.focusCallback.emit($event);
        }
    }
    /**
     * emit an Output function on change
     */
    onBlur($event = null) {
        this.isFocused = false;
        if (this.blurCallback.observers.length) {
            this.blurCallback.emit($event);
        }
    }
    onKeyDown(event) {
        if (this.keyDownCallback.observers.length) {
            this.keyDownCallback.emit(event);
        }
    }
    onKeyUp(event) {
        if (this.keyUpCallback.observers.length) {
            this.keyUpCallback.emit(event);
        }
    }
    getErrorMsg() {
        return this.handleErrorValidation ? this.amdocsFunctionsService.getErrorMsg(this.control, this.errorsMessages) : null;
    }
    isInvalid() {
        return this.control.invalid && this.control.dirty && !this.isFocused;
    }
    getInputValue() {
        if (this.getValueFormatted) {
            return this.getValueFormatted(this.control.value);
        }
        return this.control.value + '$';
    }
}
AmdocsControlAbstract.ɵfac = function AmdocsControlAbstract_Factory(t) { return new (t || AmdocsControlAbstract)(ɵɵdirectiveInject(AmdocsFunctionsService)); };
AmdocsControlAbstract.ɵcmp = ɵɵdefineComponent({ type: AmdocsControlAbstract, selectors: [["ng-component"]], inputs: { control: "control", errorsMessages: "errorsMessages", customClass: "customClass", getValueFormatted: "getValueFormatted", elementId: "elementId", inputPipe: "inputPipe", label: "label", placeHolder: "placeHolder", readOnly: "readOnly", inputMaxLength: "inputMaxLength", inputMode: "inputMode", textCenter: "textCenter", hideLabel: "hideLabel", showValidationErrorText: "showValidationErrorText" }, outputs: { onChangedCallback: "onChangedCallback", focusCallback: "focusCallback", blurCallback: "blurCallback", keyDownCallback: "keyDownCallback", keyUpCallback: "keyUpCallback" }, decls: 0, vars: 0, template: function AmdocsControlAbstract_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsControlAbstract, [{
        type: Component,
        args: [{
                template: ''
            }]
    }], function () { return [{ type: AmdocsFunctionsService }]; }, { control: [{
            type: Input
        }], errorsMessages: [{
            type: Input
        }], customClass: [{
            type: Input
        }], getValueFormatted: [{
            type: Input
        }], elementId: [{
            type: Input
        }], inputPipe: [{
            type: Input
        }], label: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], inputMaxLength: [{
            type: Input
        }], inputMode: [{
            type: Input
        }], textCenter: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], showValidationErrorText: [{
            type: Input
        }], onChangedCallback: [{
            type: Output
        }], focusCallback: [{
            type: Output
        }], blurCallback: [{
            type: Output
        }], keyDownCallback: [{
            type: Output
        }], keyUpCallback: [{
            type: Output
        }] }); })();

const _c0 = function (a0, a1, a2) { return { "text-small-bold": a0, "text-small-normal": a1, "disabled": a2 }; };
const _c1 = ["*"];
class AmdocsCheckboxComponent extends AmdocsControlAbstract {
    ngOnInit() {
        super.ngOnInit();
    }
}
AmdocsCheckboxComponent.ɵfac = function AmdocsCheckboxComponent_Factory(t) { return ɵAmdocsCheckboxComponent_BaseFactory(t || AmdocsCheckboxComponent); };
AmdocsCheckboxComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsCheckboxComponent, selectors: [["lib-amdocs-checkbox"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 6, vars: 12, consts: [[1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "formControl", "id", "change"], [1, "custom-control-indicator", "d-flex", "align-items-center", "justify-content-center"], [1, "custom-control-description", "d-flex", "align-items-center", "justify-content-center", 3, "ngClass"]], template: function AmdocsCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "label", 0);
        ɵɵelementStart(2, "input", 1);
        ɵɵlistener("change", function AmdocsCheckboxComponent_Template_input_change_2_listener() { return ctx.onChange(); });
        ɵɵelementEnd();
        ɵɵelement(3, "span", 2);
        ɵɵelementStart(4, "span", 3);
        ɵɵprojection(5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("amdocs-form-checkbox ", ctx.customClass, "");
        ɵɵadvance(1);
        ɵɵattribute("for", ctx.elementId);
        ɵɵadvance(1);
        ɵɵproperty("formControl", ctx.control)("id", ctx.elementId);
        ɵɵattribute("disabled", ctx.isDisabled() ? ctx.isDisabled() : null);
        ɵɵadvance(2);
        ɵɵproperty("ngClass", ɵɵpureFunction3(8, _c0, ctx.control.value, !ctx.control.value, ctx.isDisabled()));
    } }, directives: [CheckboxControlValueAccessor, NgControlStatus, FormControlDirective, NgClass], styles: [".amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]{align-items:center;display:flex;margin:0;padding:0}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]{background-color:#f1f1f4;border:2px solid #22212e;border-radius:8px;content:\"\";display:inline-block;height:24px;margin:0 12px;opacity:.5;transition:border .5s;width:24px}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]:hover{cursor:pointer}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]{display:none}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]:checked + .custom-control-indicator[_ngcontent-%COMP%]{border-width:12px;opacity:1;transition:.5s}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]:checked + .custom-control-indicator[_ngcontent-%COMP%]:after{animation-delay:.3s;animation-duration:.2s;animation-fill-mode:forwards;animation-name:fadeIn;content:url(/assets/icons/checkmark-icon.svg);opacity:1;position:relative;top:1px;transform:scale(0)}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]:disabled + .custom-control-indicator[_ngcontent-%COMP%]{border-color:#c9c9d3}.amdocs-form-checkbox[_ngcontent-%COMP%]   label.custom-control[_ngcontent-%COMP%]   .custom-control-description.disabled[_ngcontent-%COMP%]{color:#c9c9d3}@keyframes fadeIn{0%{transform:scale(0)}50%{transform:scale(1.3)}to{transform:scale(1)}}@keyframes fadeOut{0%{transform:scale(1)}50%{transform:scale(1.3)}to{transform:scale(0)}}"] });
const ɵAmdocsCheckboxComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsCheckboxComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-checkbox',
                templateUrl: './amdocs-checkbox.component.html',
                styleUrls: ['./amdocs-checkbox.component.scss']
            }]
    }], null, null); })();

function AmdocsSwitcherComponent_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r1.labelText);
} }
function AmdocsSwitcherComponent_div_5_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 9);
} }
function AmdocsSwitcherComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 6);
    ɵɵtemplate(1, AmdocsSwitcherComponent_div_5_span_1_Template, 2, 1, "span", 7);
    ɵɵtemplate(2, AmdocsSwitcherComponent_div_5_img_2_Template, 1, 0, "img", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.labelText);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
class AmdocsSwitcherComponent extends AmdocsControlAbstract {
    constructor() {
        super(...arguments);
        this.isRequired = false;
        this.hideLabel = false;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    getAriaDescribedBy() {
        return this.ariaDescribedBy ? this.ariaDescribedBy : this.errorElementId;
    }
    get errorElementId() {
        return `${this.elementId}-error-label`;
    }
}
AmdocsSwitcherComponent.ɵfac = function AmdocsSwitcherComponent_Factory(t) { return ɵAmdocsSwitcherComponent_BaseFactory(t || AmdocsSwitcherComponent); };
AmdocsSwitcherComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsSwitcherComponent, selectors: [["lib-amdocs-switcher"]], inputs: { labelText: "labelText", isRequired: "isRequired", hideLabel: "hideLabel", ariaLabel: "ariaLabel", ariaLabeledBy: "ariaLabeledBy", ariaDescribedBy: "ariaDescribedBy" }, features: [ɵɵInheritDefinitionFeature], decls: 6, vars: 8, consts: [[1, "amdocs-switcher-wrapper"], [1, "amdocs-switcher-control-wrapper", "d-flex"], [1, "amdocs-switcher-control"], ["type", "checkbox", 1, "switcher-checkbox", 3, "id", "formControl", "disabled", "change"], [1, "switcher-indicator", 3, "for"], ["class", "switcher-label text-color-primary d-flex", 4, "ngIf"], [1, "switcher-label", "text-color-primary", "d-flex"], [4, "ngIf"], ["class", "autocomplete-img", "src", "assets/icons/asterisk.svg", 4, "ngIf"], ["src", "assets/icons/asterisk.svg", 1, "autocomplete-img"]], template: function AmdocsSwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("change", function AmdocsSwitcherComponent_Template_input_change_3_listener() { return ctx.onChange(); });
        ɵɵelementEnd();
        ɵɵelement(4, "label", 4);
        ɵɵelementEnd();
        ɵɵtemplate(5, AmdocsSwitcherComponent_div_5_Template, 3, 2, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵpropertyInterpolate("id", ctx.elementId);
        ɵɵproperty("formControl", ctx.control)("disabled", ctx.isDisabled());
        ɵɵattribute("aria-label", ctx.ariaLabel)("aria-labeledby", ctx.ariaLabeledBy)("aria-describedby", ctx.getAriaDescribedBy());
        ɵɵadvance(1);
        ɵɵproperty("for", ctx.elementId);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.hideLabel);
    } }, directives: [CheckboxControlValueAccessor, NgControlStatus, FormControlDirective, NgIf], styles: [".amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]{display:inline-block;height:32px;position:relative;width:60px}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input.switcher-checkbox[_ngcontent-%COMP%]{left:-1000px;outline:none!important;position:fixed;top:-1000px}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input.switcher-checkbox[_ngcontent-%COMP%]:active, .amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input.switcher-checkbox[_ngcontent-%COMP%]:focus, .amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input.switcher-checkbox[_ngcontent-%COMP%]:hover{outline:none!important}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]{background-color:#ee9497;border-color:#ee9497}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:hover + label[_ngcontent-%COMP%]{cursor:pointer}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:after{color:#f05c62;left:28px}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   label.switcher-indicator[_ngcontent-%COMP%]{background-color:#c9c9d3;border:2px solid #c9c9d3;border-radius:16px;height:100%;left:0;margin-bottom:0;position:absolute;top:0;transition:background-color .15s ease-in-out;width:100%}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control[_ngcontent-%COMP%]   label.switcher-indicator[_ngcontent-%COMP%]:after{background:#fff;border:1px solid #fff;border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,.23);content:\"\";display:block;height:28px;left:1px;position:absolute;top:0;transition:left .15s ease-in-out;width:28px}.amdocs-switcher-wrapper[_ngcontent-%COMP%]   .amdocs-switcher-control-wrapper[_ngcontent-%COMP%]   .switcher-label[_ngcontent-%COMP%]{align-items:center;padding:0 20px}"] });
const ɵAmdocsSwitcherComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsSwitcherComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsSwitcherComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-switcher',
                templateUrl: './amdocs-switcher.component.html',
                styleUrls: ['./amdocs-switcher.component.scss']
            }]
    }], null, { labelText: [{
            type: Input
        }], isRequired: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaLabeledBy: [{
            type: Input
        }], ariaDescribedBy: [{
            type: Input
        }] }); })();

const _c0$1 = ["dropDownItem"];
const _c1$1 = ["dropDownSelectedItem"];
function AmdocsDropdownComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵelement(1, "img", 8);
    ɵɵelementStart(2, "span", 9);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r0.getErrorMsg());
} }
function AmdocsDropdownComponent_ul_8_ng_container_1_ng_container_3_ng_template_1_Template(rf, ctx) { }
const _c2 = function (a0) { return [a0]; };
function AmdocsDropdownComponent_ul_8_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsDropdownComponent_ul_8_ng_container_1_ng_container_3_ng_template_1_Template, 0, 0, "ng-template", 16);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ɵɵnextContext().$implicit;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpureFunction1(2, _c2, item_r3))("ngForTemplate", ctx_r5.dropDownItem);
} }
function AmdocsDropdownComponent_ul_8_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r3.value, " ");
} }
function AmdocsDropdownComponent_ul_8_ng_container_1_li_5_ng_container_2_ng_template_1_Template(rf, ctx) { }
function AmdocsDropdownComponent_ul_8_ng_container_1_li_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsDropdownComponent_ul_8_ng_container_1_li_5_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 16);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r12 = ɵɵnextContext().$implicit;
    const ctx_r14 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpureFunction1(2, _c2, item_r12))("ngForTemplate", ctx_r14.dropDownItem);
} }
function AmdocsDropdownComponent_ul_8_ng_container_1_li_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r12 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r12.value, " ");
} }
const _c3 = function (a0, a1) { return { "disabled": a0, "selected": a1 }; };
function AmdocsDropdownComponent_ul_8_ng_container_1_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 12);
    ɵɵlistener("click", function AmdocsDropdownComponent_ul_8_ng_container_1_li_5_Template_li_click_0_listener($event) { ɵɵrestoreView(_r21); const item_r12 = ctx.$implicit; const ctx_r20 = ɵɵnextContext(3); return ctx_r20.itemClick($event, item_r12); });
    ɵɵelementStart(1, "a", 17);
    ɵɵtemplate(2, AmdocsDropdownComponent_ul_8_ng_container_1_li_5_ng_container_2_Template, 2, 4, "ng-container", 14);
    ɵɵtemplate(3, AmdocsDropdownComponent_ul_8_ng_container_1_li_5_ng_container_3_Template, 2, 1, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r7 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(3, _c3, item_r12.disabled, item_r12.key == ctx_r7.control.value));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r7.dropDownItem);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r7.dropDownItem);
} }
function AmdocsDropdownComponent_ul_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "li", 12);
    ɵɵlistener("click", function AmdocsDropdownComponent_ul_8_ng_container_1_Template_li_click_1_listener($event) { ɵɵrestoreView(_r23); const item_r3 = ctx.$implicit; const ctx_r22 = ɵɵnextContext(2); return ctx_r22.itemClick($event, item_r3); });
    ɵɵelementStart(2, "a", 13);
    ɵɵtemplate(3, AmdocsDropdownComponent_ul_8_ng_container_1_ng_container_3_Template, 2, 4, "ng-container", 14);
    ɵɵtemplate(4, AmdocsDropdownComponent_ul_8_ng_container_1_ng_container_4_Template, 2, 1, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(5, AmdocsDropdownComponent_ul_8_ng_container_1_li_5_Template, 4, 6, "li", 15);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction2(4, _c3, item_r3.disabled, item_r3.key == ctx_r2.control.value));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.dropDownItem);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.dropDownItem);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", item_r3.subDropDownItems);
} }
const _c4 = function (a0) { return { "full-width": a0 }; };
function AmdocsDropdownComponent_ul_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ul", 10);
    ɵɵtemplate(1, AmdocsDropdownComponent_ul_8_ng_container_1_Template, 6, 7, "ng-container", 11);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c4, ctx_r1.fullWith));
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.items);
} }
const _c5 = function (a0) { return { "placeholder": a0 }; };
class AmdocsDropdownComponent extends AmdocsControlAbstract {
    constructor() {
        super(...arguments);
        this.fullWith = true;
        this.items = [];
        this.autoClose = true;
        this.placeHolder = 'select';
        this.selectIfOneItem = false;
    }
    ngOnInit() {
        var _a;
        super.ngOnInit();
        if (((_a = this.items) === null || _a === void 0 ? void 0 : _a.length) === 1 && this.selectIfOneItem) {
            this.control.setValue(this.items[0].key);
            this.onChange();
        }
    }
    get selectedValue() {
        if (this.control && this.control.value) {
            const itemFound = this.items.find(i => i.key === this.control.value);
            if (itemFound) {
                return itemFound.value;
            }
            else {
                for (let i = 0; i <= this.items.length; i++) {
                    if (this.items[i].subDropDownItems) {
                        return this.items[i].subDropDownItems.find(subItem => subItem.key === this.control.value).value;
                    }
                }
            }
        }
        return this.placeHolder;
    }
    itemClick(event, item) {
        if (item.disabled) {
            event.stopPropagation();
            return;
        }
        this.control.setValue(item.key);
        this.onChange();
    }
}
AmdocsDropdownComponent.ɵfac = function AmdocsDropdownComponent_Factory(t) { return ɵAmdocsDropdownComponent_BaseFactory(t || AmdocsDropdownComponent); };
AmdocsDropdownComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsDropdownComponent, selectors: [["lib-amdocs-dropdown"]], contentQueries: function AmdocsDropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, _c0$1, true);
        ɵɵcontentQuery(dirIndex, _c1$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dropDownItem = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dropDownSelectedItem = _t.first);
    } }, inputs: { fullWith: "fullWith", items: "items", autoClose: "autoClose", placeHolder: "placeHolder", selectIfOneItem: "selectIfOneItem" }, features: [ɵɵInheritDefinitionFeature], decls: 9, vars: 19, consts: [["dropdown", "", 3, "autoClose", "isDisabled"], [1, "custom-input-label"], ["dropdownToggle", "", "type", "button", "aria-controls", "dropdown-basic", 1, "custom-input-field-control", "dropdown-toggle", "d-flex", "align-items-center", "justify-content-between", 3, "id", "focus", "blur"], [1, "selected-value", 3, "ngClass"], ["src", "/assets/icons/arrow-down.svg", 1, "caret"], ["class", "custom-input-field-error", 4, "ngIf"], ["class", "dropdown-menu", "role", "menu", "aria-labelledby", "button-basic", 3, "ngClass", 4, "dropdownMenu"], [1, "custom-input-field-error"], ["src", "/assets/icons/error.svg"], [1, "text-small-normal"], ["role", "menu", "aria-labelledby", "button-basic", 1, "dropdown-menu", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["role", "menuitem", 1, "menu-item", 3, "click"], ["href", "javascript:void(0)", 1, "dropdown-item", 3, "ngClass"], [4, "ngIf"], ["class", "menu-item", "role", "menuitem", 3, "click", 4, "ngFor", "ngForOf"], ["ngFor", "", 3, "ngForOf", "ngForTemplate"], ["href", "javascript:void(0)", 1, "dropdown-item", "dropdown-sub-item", 3, "ngClass"]], template: function AmdocsDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "button", 2);
        ɵɵlistener("focus", function AmdocsDropdownComponent_Template_button_focus_3_listener() { return ctx.onFocus(); })("blur", function AmdocsDropdownComponent_Template_button_blur_3_listener() { return ctx.onBlur(); });
        ɵɵelementStart(4, "span", 3);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelement(6, "img", 4);
        ɵɵelementEnd();
        ɵɵtemplate(7, AmdocsDropdownComponent_div_7_Template, 4, 1, "div", 5);
        ɵɵtemplate(8, AmdocsDropdownComponent_ul_8_Template, 2, 4, "ul", 6);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("amdocs-dropdown btn-group ", ctx.customClass, "");
        ɵɵproperty("autoClose", ctx.autoClose)("isDisabled", ctx.isDisabled());
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.label);
        ɵɵadvance(1);
        ɵɵclassProp("active", ctx.control.value)("invalid", ctx.isInvalid())("readonly", ctx.readOnly);
        ɵɵproperty("id", ctx.elementId);
        ɵɵattribute("disabled", ctx.isDisabled());
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction1(17, _c5, !ctx.control.value));
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.selectedValue);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.isInvalid() && ctx.showValidationErrorText);
    } }, directives: [BsDropdownDirective, BsDropdownToggleDirective, NgClass, NgIf, BsDropdownMenuDirective, NgForOf], styles: [".amdocs-dropdown[_ngcontent-%COMP%]{display:block;width:100%}.amdocs-dropdown[_ngcontent-%COMP%]   .custom-input-field-control[_ngcontent-%COMP%]   .selected-value[_ngcontent-%COMP%]{max-width:calc(100% - 25px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]{font-weight:400;width:100%}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:focus{outline:none}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{border-radius:8px;margin:0;padding:16px 0}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu.full-width[_ngcontent-%COMP%]{width:100%}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu.full-width[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{white-space:inherit}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   li.menu-item[_ngcontent-%COMP%]{cursor:pointer}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   li.menu-item[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{align-items:center;border-bottom:1px solid #f1f1f4;display:flex;height:52px;margin:0;padding:0 12px}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   li.menu-item[_ngcontent-%COMP%]   .dropdown-item.dropdown-sub-item[_ngcontent-%COMP%]{padding-left:25px}.amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   li.menu-item[_ngcontent-%COMP%]   .dropdown-item.selected[_ngcontent-%COMP%], .amdocs-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   li.menu-item[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:hover{background-color:#f05c62;color:#fff}"] });
const ɵAmdocsDropdownComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsDropdownComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-dropdown',
                templateUrl: './amdocs-dropdown.component.html',
                styleUrls: ['./amdocs-dropdown.component.scss']
            }]
    }], null, { fullWith: [{
            type: Input
        }], items: [{
            type: Input
        }], autoClose: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], selectIfOneItem: [{
            type: Input
        }], dropDownItem: [{
            type: ContentChild,
            args: ['dropDownItem']
        }], dropDownSelectedItem: [{
            type: ContentChild,
            args: ['dropDownSelectedItem']
        }] }); })();
class DropdownItem {
    constructor(key, value, subDropDownItems, disabled = false) {
        this.key = key;
        this.value = value;
        this.subDropDownItems = subDropDownItems;
        this.disabled = disabled;
    }
}

class AmdocsMimicComponent {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.fileNumber = '';
    }
    ngOnInit() {
    }
    toggleMimic() {
        const m = localStorage.getItem('mimic');
        if (!m) {
            localStorage.setItem('mimic', '1');
            window.location = window.location;
        }
        else {
            localStorage.removeItem('mimic');
            window.location = window.location;
        }
    }
    switchFile() {
        this.httpClient.get(`https://mimics.stage-rc.com/amdocs/${this.fileNumber}.json`).subscribe((response) => {
            localStorage.setItem('mimic', '1');
            localStorage.setItem('_mimic_', JSON.stringify(response));
            setTimeout(() => {
                window.location.reload();
            }, 200);
        }, (error) => {
            alert(`${error.status} - ${error.message}`);
        });
    }
    go() {
        window.location.href = this.fileNumber;
    }
}
AmdocsMimicComponent.ɵfac = function AmdocsMimicComponent_Factory(t) { return new (t || AmdocsMimicComponent)(ɵɵdirectiveInject(HttpClient)); };
AmdocsMimicComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsMimicComponent, selectors: [["lib-amdocs-mimic"]], decls: 8, vars: 1, consts: [[1, "mimic-wrapper"], [1, "btn", "toggle-btn", 3, "click"], [3, "ngModel", "ngModelChange"], [3, "click"]], template: function AmdocsMimicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "button", 1);
        ɵɵlistener("click", function AmdocsMimicComponent_Template_button_click_1_listener() { return ctx.toggleMimic(); });
        ɵɵtext(2, "RC");
        ɵɵelementEnd();
        ɵɵelementStart(3, "input", 2);
        ɵɵlistener("ngModelChange", function AmdocsMimicComponent_Template_input_ngModelChange_3_listener($event) { return ctx.fileNumber = $event; });
        ɵɵelementEnd();
        ɵɵelementStart(4, "button", 3);
        ɵɵlistener("click", function AmdocsMimicComponent_Template_button_click_4_listener() { return ctx.switchFile(); });
        ɵɵtext(5, "Switch");
        ɵɵelementEnd();
        ɵɵelementStart(6, "button", 3);
        ɵɵlistener("click", function AmdocsMimicComponent_Template_button_click_6_listener() { return ctx.go(); });
        ɵɵtext(7, "GO");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("ngModel", ctx.fileNumber);
    } }, directives: [DefaultValueAccessor, NgControlStatus, NgModel], styles: [".mimic-wrapper[_ngcontent-%COMP%]{align-items:center;bottom:10px;display:flex;flex-direction:row;font-size:18px;justify-content:flex-start;position:fixed;right:10px;text-align:center;z-index:1000}.mimic-wrapper[_ngcontent-%COMP%]   .toggle-btn[_ngcontent-%COMP%]{background-color:#c1d72e;border:none;border-radius:50px;box-shadow:0 0 1px 1px grey;color:#fff;direction:ltr;display:inline-block;font-weight:700;padding-left:8px;padding-top:8px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsMimicComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-mimic',
                templateUrl: './amdocs-mimic.component.html',
                styleUrls: ['./amdocs-mimic.component.scss']
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

function AmdocsPopupComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 5);
    ɵɵlistener("click", function AmdocsPopupComponent_div_4_Template_div_click_0_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.close(); });
    ɵɵelement(1, "img", 6);
    ɵɵelementEnd();
} }
const _c0$2 = ["*"];
class AmdocsPopupComponent {
    constructor() {
        this.showCloseButton = false;
        this.closeCallback = new EventEmitter();
        this.config = {};
    }
    ngOnInit() {
        this.config = Object.assign({ ignoreBackdropClick: true }, this.config);
    }
    ngAfterViewInit() {
        this.modal.show();
    }
    close() {
        if (this.modal) {
            this.modal.config = this.config;
            this.modal.hide();
        }
    }
    /**
     * on popup hide
     */
    onHide() {
        if (this.closeCallback.observers.length) {
            this.closeCallback.emit();
        }
    }
}
AmdocsPopupComponent.ɵfac = function AmdocsPopupComponent_Factory(t) { return new (t || AmdocsPopupComponent)(); };
AmdocsPopupComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsPopupComponent, selectors: [["lib-amdocs-popup"]], viewQuery: function AmdocsPopupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(ModalDirective, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.modal = _t.first);
    } }, inputs: { showCloseButton: "showCloseButton", customClass: "customClass" }, outputs: { closeCallback: "closeCallback" }, ngContentSelectors: _c0$2, decls: 7, vars: 5, consts: [["bsModal", "", "tabindex", "-1", "role", "dialog", "aria-labelledby", "dialog-static-name", 1, "modal", "fade", 3, "config", "onHidden"], ["modal", "bs-modal"], [1, "modal-dialog", "modal-sm"], ["class", "close-popup-button", "role", "button", 3, "click", 4, "ngIf"], [1, "modal-body"], ["role", "button", 1, "close-popup-button", 3, "click"], ["src", "/assets/icons/popup-close.svg"]], template: function AmdocsPopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0, 1);
        ɵɵlistener("onHidden", function AmdocsPopupComponent_Template_div_onHidden_0_listener() { return ctx.onHide(); });
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div");
        ɵɵtemplate(4, AmdocsPopupComponent_div_4_Template, 2, 0, "div", 3);
        ɵɵelementStart(5, "div", 4);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("config", ctx.config);
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("modal-content ", ctx.customClass, "");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showCloseButton);
    } }, directives: [ModalDirective, NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPopupComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-popup',
                templateUrl: './amdocs-popup.component.html',
                styleUrls: ['./amdocs-popup.component.scss']
            }]
    }], function () { return []; }, { showCloseButton: [{
            type: Input
        }], customClass: [{
            type: Input
        }], closeCallback: [{
            type: Output
        }], modal: [{
            type: ViewChild,
            args: [ModalDirective]
        }] }); })();

class AmdocsDeviceService {
    // public portraitMode: boolean;
    constructor(deviceService) {
        this.deviceService = deviceService;
    }
    isMobile() {
        return this.deviceService.isMobile();
    }
    isIos() {
        const userAgent = navigator.userAgent || navigator.vendor;
        return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
    }
    isSafari() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1) {
            if (ua.indexOf('chrome') > -1) {
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    }
    isChromeIOS() {
        const ua = navigator.userAgent.toLowerCase();
        return this.isSafari() && ua.indexOf('crios') > -1;
    }
    isAndroid() {
        return (this.isMobile() && !this.isIos());
    }
}
AmdocsDeviceService.ɵfac = function AmdocsDeviceService_Factory(t) { return new (t || AmdocsDeviceService)(ɵɵinject(DeviceDetectorService)); };
AmdocsDeviceService.ɵprov = ɵɵdefineInjectable({ token: AmdocsDeviceService, factory: AmdocsDeviceService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsDeviceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DeviceDetectorService }]; }, null); })();

class AmdocsCookieService {
    constructor(cookieService) {
        this.cookieService = cookieService;
    }
    get(key) {
        return this.cookieService.get(key);
    }
    check(key) {
        return this.cookieService.check(key);
    }
    set(name, value, options) {
        return this.cookieService.set(name, value, options);
    }
    delete(name, path, domain, secure, sameSite) {
        return this.cookieService.delete(name, path, domain, secure, sameSite);
    }
}
AmdocsCookieService.ɵfac = function AmdocsCookieService_Factory(t) { return new (t || AmdocsCookieService)(ɵɵinject(CookieService)); };
AmdocsCookieService.ɵprov = ɵɵdefineInjectable({ token: AmdocsCookieService, factory: AmdocsCookieService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsCookieService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CookieService }]; }, null); })();

// export class ApiResponse {
//   constructor(
//     public result: any,
//     public isOK: boolean,
//     public error: ApiError
//   ){}
// }
class ApiError {
    constructor(code, message, errorType) {
        this.code = code;
        this.message = message;
        this.errorType = errorType;
    }
}

var LANGUAGE;
(function (LANGUAGE) {
    // TODO SET LANGUAGE OPTIONS
    LANGUAGE["hebrew"] = "heb";
    LANGUAGE["english"] = "english";
})(LANGUAGE || (LANGUAGE = {}));

var EToasterType;
(function (EToasterType) {
    EToasterType["success"] = "success";
    EToasterType["info"] = "info";
    EToasterType["warning"] = "warning";
    EToasterType["error"] = "error";
})(EToasterType || (EToasterType = {}));

class AmdocsTranslateService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    loadTranslate(lang = null) {
        const fileName = lang === LANGUAGE.hebrew ? 'he.json' : 'en.json';
        return this.httpClient.get(`/assets/translate/${fileName}`).pipe(mergeMap((json) => {
            this.setTranslation(json);
            return of(true);
        }));
    }
    /**
     * Set resource object
     * @param obj - translation object
     */
    setTranslation(obj) {
        this.textTranslation = obj;
    }
    /**
     * Get resource value
     * @param key - translation key
     * @param placeholdersReplace - translation placeholder
     * @returns string
     */
    getText(key, placeholdersReplace = []) {
        if (!key) {
            return '';
        }
        let value = key.split('.')
            .reduce((previous, current) => previous[current], this.textTranslation) || '';
        if (value.length > 0) {
            if (placeholdersReplace && Array.isArray(placeholdersReplace) && placeholdersReplace.length > 0) {
                value = this.replacePlaceholders(value, placeholdersReplace);
            }
            return value;
        }
        return key;
    }
    /**
     * @param text - replacement text
     * @param placeholders - replacement placeholder
     * @returns string
     */
    replacePlaceholders(text, placeholders) {
        if (!text) {
            return '';
        }
        let counter = 0;
        placeholders.forEach((placeholder) => {
            if (placeholder) {
                placeholder = placeholder.toString();
                text = text.replace(`{${counter}}`, placeholder);
            }
            counter++;
        });
        return text;
    }
    mergeDeep(target, source) {
        if (typeof (target) === 'object' && typeof (source) === 'object') {
            for (const key in source) {
                if (typeof (source[key]) === 'object') {
                    if (!target[key]) {
                        Object.assign(target, { [key]: {} });
                    }
                    this.mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return target;
    }
}
AmdocsTranslateService.ɵfac = function AmdocsTranslateService_Factory(t) { return new (t || AmdocsTranslateService)(ɵɵinject(HttpClient)); };
AmdocsTranslateService.ɵprov = ɵɵdefineInjectable({ token: AmdocsTranslateService, factory: AmdocsTranslateService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTranslateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

const AMDOCS_CONSTANTS = {
    PKCE_EXPIRATION: 'pkce_expiration',
    TOKEN_KEY: 'open_id_token',
    TOKEN_EXPIRATION_KEY: 'open_id_token_expiration',
    CAS_TOKEN_KEY: 'cas_token',
    CAS_TOKEN_EXPIRATION_KEY: 'cas_token_expiration',
    ACCESS_KEY_ID: 'AccessKeyId',
    SECRET_ACCESS_KEY: 'SecretAccessKey',
    SESSION_TOKEN: 'SessionToken',
    EXPIRATION: 'expiration',
    SHOW_NEW_VERSION_ALERT_EVENT: 'show-new-version-alert-event',
    API_ERROR_EVENT: 'global-api-error-event'
};

class AmdocsApiUtilsService {
    constructor() { }
    handleGatewayResponse(responseObs) {
        return responseObs.pipe(mergeMap((response) => {
            // TODO:: check for errors
            return of(response.data);
        }), catchError((err) => {
            let errorMsg = err.toString();
            let code = 0;
            if (err.status !== 200) {
                errorMsg = err.data.message;
                code = err.status;
            }
            return this.handleError(errorMsg, code);
        }));
    }
    handleError(errorMessage, code = 0) {
        const apiError = new ApiError(code, errorMessage);
        return throwError(apiError);
    }
}
AmdocsApiUtilsService.ɵfac = function AmdocsApiUtilsService_Factory(t) { return new (t || AmdocsApiUtilsService)(); };
AmdocsApiUtilsService.ɵprov = ɵɵdefineInjectable({ token: AmdocsApiUtilsService, factory: AmdocsApiUtilsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsApiUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AmdocsGatewayClientService {
    constructor(appGatewayConfig, loginGatewayConfig, amdocsApiService, amdocsCookieService) {
        this.amdocsApiService = amdocsApiService;
        this.amdocsCookieService = amdocsCookieService;
        this.appGatewayConfig = appGatewayConfig;
        this.loginGatewayConfig = loginGatewayConfig;
    }
    getAppApiGatewayClient(useAws4AuthType = false) {
        return this.getApiGwClient(this.appGatewayConfig, useAws4AuthType);
    }
    getLoginApiGatewayClient(useAws4AuthType = false) {
        return this.getApiGwClient(this.loginGatewayConfig, useAws4AuthType);
    }
    getApiGwClient(gwConfig, useAws4AuthType = false, withCredentials = true) {
        const config = {
            invokeUrl: gwConfig.url,
            region: gwConfig.region,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: '',
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json',
            appid: gwConfig.appid
        };
        if (withCredentials) {
            config.accessKey = decodeURIComponent(this.amdocsCookieService.get(AMDOCS_CONSTANTS.ACCESS_KEY_ID));
            config.secretKey = decodeURIComponent(this.amdocsCookieService.get(AMDOCS_CONSTANTS.SECRET_ACCESS_KEY));
            config.sessionToken = decodeURIComponent(this.amdocsCookieService.get(AMDOCS_CONSTANTS.SESSION_TOKEN));
        }
        const apigClient = {};
        const invokeUrl = config.invokeUrl;
        const part = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl);
        const endpoint = part ? part[1] : '';
        const pathComponent = invokeUrl.substring(endpoint.length);
        const sigV4ClientConfig = {
            accessKey: config.accessKey,
            secretKey: config.secretKey,
            sessionToken: config.sessionToken,
            serviceName: 'execute-api',
            region: config.region,
            endpoint: endpoint,
            defaultContentType: config.defaultContentType,
            defaultAcceptType: config.defaultAcceptType
        };
        let authType = 'NONE'; // for login gateway
        if (useAws4AuthType && (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== '' && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '')) {
            authType = 'AWS_IAM'; // For application gateway
        }
        const simpleHttpClientConfig = {
            endpoint: endpoint,
            defaultContentType: config.defaultContentType,
            defaultAcceptType: config.defaultAcceptType
        };
        const apiGatewayClient = apiGateway.core.apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig);
        apigClient.call = (url, method, params = {}, body = {}, additionalParams = {}) => {
            if (!params) {
                params = {};
            }
            apiGateway.core.utils.assertParametersDefined(params, [], ['body']);
            params.appid = config.appid;
            const reqHeaders = apiGateway.core.utils.parseParametersToObject(params, []);
            if (this.amdocsCookieService.get(AMDOCS_CONSTANTS.TOKEN_KEY)) {
                reqHeaders['x-id-token'] = this.amdocsCookieService.get(AMDOCS_CONSTANTS.TOKEN_KEY);
            }
            const request = {
                verb: method.toUpperCase(),
                path: pathComponent + uritemplate(url).expand(apiGateway.core.utils.parseParametersToObject(params, Object.keys(params))),
                headers: reqHeaders,
                queryParams: apiGateway.core.utils.parseParametersToObject(params, Object.keys(params)),
                body: body
            };
            return this.amdocsApiService.handleGatewayResponse(from(apiGatewayClient.makeRequest(request, authType, additionalParams, config.apiKey)));
        };
        return apigClient;
    }
}
AmdocsGatewayClientService.ɵfac = function AmdocsGatewayClientService_Factory(t) { return new (t || AmdocsGatewayClientService)(ɵɵinject('IAppGatewayConfig'), ɵɵinject('ILoginGatewayConfig'), ɵɵinject(AmdocsApiUtilsService), ɵɵinject(AmdocsCookieService)); };
AmdocsGatewayClientService.ɵprov = ɵɵdefineInjectable({ token: AmdocsGatewayClientService, factory: AmdocsGatewayClientService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsGatewayClientService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['IAppGatewayConfig']
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: ['ILoginGatewayConfig']
            }] }, { type: AmdocsApiUtilsService }, { type: AmdocsCookieService }]; }, null); })();

class AmdocsApiService {
    constructor(gatewayAPI) {
        this.gatewayAPI = gatewayAPI;
    }
    getLoginUrl() {
        return this.gatewayAPI.getLoginApiGatewayClient().call('/oidc/login', 'get').pipe(mergeMap((response) => {
            return of(response);
        }));
    }
    refreshToken() {
        return this.gatewayAPI.getLoginApiGatewayClient().call('/oidc/refresh', 'get').pipe(mergeMap((response) => {
            return of(response);
        }));
    }
    getLogoutUrl() {
        return this.gatewayAPI.getLoginApiGatewayClient().call('/oidc/logout', 'post').pipe(mergeMap((response) => {
            return of(response);
        }));
    }
    login(code) {
        const params = {
            code: code
        };
        return this.gatewayAPI.getLoginApiGatewayClient().call('/oidc/token', 'get', params).pipe(mergeMap((response) => {
            return of(response);
        }));
    }
}
AmdocsApiService.ɵfac = function AmdocsApiService_Factory(t) { return new (t || AmdocsApiService)(ɵɵinject(AmdocsGatewayClientService)); };
AmdocsApiService.ɵprov = ɵɵdefineInjectable({ token: AmdocsApiService, factory: AmdocsApiService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AmdocsGatewayClientService }]; }, null); })();

class AmdocsTimeService {
    constructor() {
        this.momentRef = moment_;
        this.defaultViewDateFormat = 'DD/MM/YYYY';
        this.defaultViewTimeFormat = 'HH:mm';
        this.defaultViewDateTimeFormat = `${this.defaultViewDateFormat} ${this.defaultViewTimeFormat}`;
        this.defaultServerDateFormat = 'YYYY-MM-DD';
        this.defaultServerDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
        this.fullDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
    }
    /**
     * get moment object
     * @param dateString - string of date e.g. '2011-02-15'
     * @param dateFormat - format of date e.g. 'YYYY-MM-DD'
     */
    moment(dateString = null, dateFormat = null) {
        if (dateString === null) {
            return this.momentRef();
        }
        else {
            return this.momentRef(dateString, dateFormat);
        }
    }
    /**
     * get moment object from UTC datetime string
     * @param dateString - string of date e.g. '2011-02-15 12:00:00'
     */
    momentFromUTCToLocal(dateString) {
        return this.momentRef.utc(dateString).local();
    }
    /**
     * Format a date
     * @param date
     * @param from
     * @param to
     * @returns string
     */
    format(date, from = this.defaultViewDateFormat, to = this.defaultServerDateFormat) {
        if (this.momentRef(date, from).isValid()) {
            return this.momentRef(date, from).format(to);
        }
        else {
            return null;
        }
    }
}
AmdocsTimeService.ɵfac = function AmdocsTimeService_Factory(t) { return new (t || AmdocsTimeService)(); };
AmdocsTimeService.ɵprov = ɵɵdefineInjectable({ token: AmdocsTimeService, factory: AmdocsTimeService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTimeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AmdocsAuthService {
    constructor(loginGatewayConfig, apiService, timeService, cookieService) {
        this.apiService = apiService;
        this.timeService = timeService;
        this.cookieService = cookieService;
        this.loginConfig = loginGatewayConfig;
    }
    getToken() {
        return this.cookieService.get(AMDOCS_CONSTANTS.TOKEN_KEY);
    }
    setRefreshTokenInterval() {
        this.clearRefreshTokenInterval();
        this.refreshTokenThread = setInterval(() => {
            this.refreshUserToken();
        }, this.loginConfig.refreshTokenInterval);
    }
    clearRefreshTokenInterval() {
        if (this.refreshTokenThread) {
            clearInterval(this.refreshTokenThread);
        }
    }
    getLoginURL() {
        return this.apiService.getLoginUrl().pipe(mergeMap((response) => {
            return of(response);
        }));
    }
    setpkceExp(pkceExp) {
        const options = {
            path: '/',
            secure: true
        };
        this.cookieService.set(AMDOCS_CONSTANTS.PKCE_EXPIRATION, `${pkceExp}`, options);
    }
    refreshUserToken() {
        this.clearRefreshTokenInterval();
        this.callRefreshUserToken().pipe(mergeMap((response) => {
            this.setRefreshTokenInterval();
            return of(response);
        })).subscribe();
    }
    callRefreshUserToken() {
        return this.apiService.refreshToken().pipe(mergeMap((response) => {
            this.setLoginCredentials(response);
            return of(response);
        }), catchError((error) => {
            this.initGetLoginUrlFlow().subscribe();
            return throwError(error);
        }));
    }
    initGetLoginUrlFlow() {
        console.log('init get login url');
        sessionStorage.removeItem('orig-path');
        return this.getLoginURL().pipe(mergeMap((response) => {
            sessionStorage.setItem('orig-path', window.location.pathname + window.location.search);
            if (response.redirectUri) {
                this.setpkceExp(response.pkceExpiration);
                window.location = response.redirectUri;
                // window.open(response.redirectUri);
                return of(new AmdocsAppInitResponse(true));
            }
            else {
                return throwError(new ApiError(0, 'could not get login url'));
            }
        }));
    }
    removePkceExp() {
        this.cookieService.delete(AMDOCS_CONSTANTS.PKCE_EXPIRATION);
    }
    isPkceValid() {
        const now = (this.timeService.moment().unix() * 1000);
        const exp = this.cookieService.get(AMDOCS_CONSTANTS.PKCE_EXPIRATION);
        if (exp) {
            return parseInt(exp, 10) > now;
        }
        return false;
    }
    hasRefreshTokenCookies() {
        const now = (this.timeService.moment().unix() * 1000);
        const exp = this.cookieService.get(AMDOCS_CONSTANTS.CAS_TOKEN_EXPIRATION_KEY);
        if (exp) {
            return parseInt(exp, 10) > now;
        }
        return false;
    }
    logout() {
        return this.apiService.getLogoutUrl().pipe(mergeMap((response) => {
            this.cookieService.deleteAll();
            window.location = response.redirectUri;
            return of(response);
        }));
    }
    login(code) {
        return this.apiService.login(code).pipe(mergeMap((response) => {
            this.setLoginCredentials(response);
            return of(response);
        }));
    }
    /**
     * return if user is logged in
     */
    isLoggedIn() {
        const token = this.getToken();
        if (token) {
            const exp = this.cookieService.get(AMDOCS_CONSTANTS.TOKEN_EXPIRATION_KEY);
            if (exp) {
                return this.isExpired(parseInt(exp, 10)) ? false : true;
            }
            else {
                return true;
            }
        }
        return false;
    }
    isExpired(exp) {
        const now = (this.timeService.moment().unix() * 1000);
        return now > exp;
    }
    idTokenIsAboutToExpired() {
        const now = (this.timeService.moment().unix() * 1000);
        const exp = this.cookieService.get(AMDOCS_CONSTANTS.TOKEN_EXPIRATION_KEY);
        if (exp) {
            return parseInt(exp, 10) - now < 2400000;
        }
        return true;
    }
    setLoginCredentials(loginCredentials) {
        const options = {
            path: '/',
            secure: true
        };
        const stsCreds = loginCredentials.stsCredentials;
        this.cookieService.set(AMDOCS_CONSTANTS.ACCESS_KEY_ID, stsCreds.accessKeyId, options);
        this.cookieService.set(AMDOCS_CONSTANTS.SECRET_ACCESS_KEY, stsCreds.secretAccessKey, options);
        this.cookieService.set(AMDOCS_CONSTANTS.SESSION_TOKEN, stsCreds.sessionToken, options);
        this.cookieService.set(AMDOCS_CONSTANTS.EXPIRATION, stsCreds.expiration, options);
        this.cookieService.set(AMDOCS_CONSTANTS.TOKEN_KEY, loginCredentials.idToken, options);
        this.cookieService.set(AMDOCS_CONSTANTS.TOKEN_EXPIRATION_KEY, loginCredentials.idTokenExpiration.toString(), options);
        this.cookieService.set(AMDOCS_CONSTANTS.CAS_TOKEN_EXPIRATION_KEY, loginCredentials.casTokenExpiration.toString(), options);
    }
}
AmdocsAuthService.ɵfac = function AmdocsAuthService_Factory(t) { return new (t || AmdocsAuthService)(ɵɵinject('ILoginGatewayConfig'), ɵɵinject(AmdocsApiService), ɵɵinject(AmdocsTimeService), ɵɵinject(CookieService)); };
AmdocsAuthService.ɵprov = ɵɵdefineInjectable({ token: AmdocsAuthService, factory: AmdocsAuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['ILoginGatewayConfig']
            }] }, { type: AmdocsApiService }, { type: AmdocsTimeService }, { type: CookieService }]; }, null); })();

/**
 * Amdocs Event Bus service
 * manage custom events
 * Each route change, unsubscribe all events listeners unless the listener was defined as global
 */
class AmdocsEventBusService {
    constructor(router) {
        this.router = router;
        this.events = [];
        this.globalEvents = [];
        this.subscriptions = [];
        this.globalSubscriptions = [];
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.clearEvents();
            }
        });
    }
    /**
     * emit an event with optional params
     * @param eventName
     * @param params
     * @param byPrefix
     */
    emit(eventName, params, byPrefix = false) {
        if (!byPrefix) {
            if (this.events[eventName]) {
                this.events[eventName].emit(params);
            }
            if (this.globalEvents[eventName]) {
                this.globalEvents[eventName].emit(params);
            }
        }
        else {
            Object.keys(this.events).forEach((fullEventName) => {
                if (fullEventName.indexOf(eventName) === 0) {
                    this.events[fullEventName].emit(params);
                }
            });
            Object.keys(this.globalEvents).forEach((fullGlobalEventName) => {
                if (fullGlobalEventName.indexOf(eventName) === 0) {
                    this.globalEvents[fullGlobalEventName].emit(params);
                }
            });
        }
    }
    /**
     * start listen to an event, if global set to true, the event listener will no unsubscribe on route change
     * @param eventName
     * @param callback
     * @param  isGlobal
     * @returns any
     */
    on(eventName, callback, isGlobal = false) {
        if (!isGlobal) {
            if (!this.events[eventName]) {
                this.events[eventName] = new EventEmitter();
            }
            if (!this.subscriptions[eventName]) {
                this.subscriptions[eventName] = [];
            }
            const globalSub = this.events[eventName].subscribe(callback);
            this.subscriptions[eventName].push(globalSub);
            return globalSub;
        }
        else {
            if (!this.globalEvents[eventName]) {
                this.globalEvents[eventName] = new EventEmitter();
            }
            if (!this.globalSubscriptions[eventName]) {
                this.globalSubscriptions[eventName] = [];
            }
            const sub = this.globalEvents[eventName].subscribe(callback);
            this.globalSubscriptions[eventName].push(sub);
            return sub;
        }
    }
    /**
     * unsubscribe all subscriber from a specific event
     * @param eventName
     * @param  isGlobal
     */
    off(eventName, isGlobal = false) {
        if (!isGlobal) {
            if (this.events[eventName]) {
                delete this.events[eventName];
            }
            if (this.subscriptions[eventName]) {
                this.subscriptions[eventName].forEach((tmpSub) => {
                    tmpSub.unsubscribe();
                });
            }
        }
        else {
            if (this.globalEvents[eventName]) {
                delete this.globalEvents[eventName];
            }
            if (this.globalSubscriptions[eventName]) {
                this.globalSubscriptions[eventName].forEach((tmpSub) => {
                    tmpSub.unsubscribe();
                });
            }
        }
    }
    /**
     * clear all events and subscriptions
     */
    clearEvents() {
        this.subscriptions.forEach((eventSubs) => {
            eventSubs.forEach((eventSub) => {
                eventSub.unsubscribe();
            });
        });
        this.subscriptions = [];
        this.events = [];
    }
}
AmdocsEventBusService.ɵfac = function AmdocsEventBusService_Factory(t) { return new (t || AmdocsEventBusService)(ɵɵinject(Router)); };
AmdocsEventBusService.ɵprov = ɵɵdefineInjectable({ token: AmdocsEventBusService, factory: AmdocsEventBusService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsEventBusService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Router }]; }, null); })();

/**
 * Amdocs Appsync Service
 * In App Module add to provider
 *
 * @example
 * const appSyncConfig: IAppSyncConfig = {
 *  url: 'the url',
 *  region: 'the region',
 * }
 * add to app module
 * {
 *   provide: 'IAppSyncConfig',
 *   useValue: appSyncConfig
 * }
 *
 */
class AmdocsAppsyncClientService {
    constructor(amdocsCookieService, amdocsApiService, httpClient, eventBus, appSyncConfig) {
        this.amdocsCookieService = amdocsCookieService;
        this.amdocsApiService = amdocsApiService;
        this.httpClient = httpClient;
        this.eventBus = eventBus;
        this.config = appSyncConfig;
    }
    getConfig() {
        return this.config;
    }
    /**
     * get id_token
     */
    getToken() {
        return this.amdocsCookieService.get(AMDOCS_CONSTANTS.TOKEN_KEY);
    }
    callCNS(query, operationName, variables = null, ignoreStatus200Errors = false) {
        return this.call(query, operationName, variables, ignoreStatus200Errors, true);
    }
    /**
     * @param query
     * @param operationName
     * @param variables
     * @param ignoreStatus200Errors
     * @param cnsCall
     * @param firstCall
     */
    call(query, operationName, variables = null, ignoreStatus200Errors = false, cnsCall = false, firstCall = true) {
        const payload = {
            operationName: operationName,
            variables: variables,
            query: query
        };
        let url = cnsCall ? this.config.cnsUrl : this.config.url;
        url += `?operationName=${operationName}`;
        return this.httpClient.post(url, payload, {
            headers: {
                authorization: this.getToken(),
                cache: 'no-store'
            }
        }).pipe(mergeMap((response) => {
            if (response === null || response === void 0 ? void 0 : response.errors) {
                if (ignoreStatus200Errors) {
                    return of(response.data);
                }
                return throwError({
                    status: 200,
                    error: {
                        errors: response.errors
                    }
                });
            }
            return of(response.data);
        }), catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                return throwError(new ApiError(error.status, error.statusText, 'http'));
            }
            if (error.status) {
                const errorStr = error.error.errors.map(e => e.message).join(', ');
                const errorTypeStr = error.error.errors.map(e => e.errorType).join(', ');
                return throwError(new ApiError(error.status, errorStr, errorTypeStr));
            }
            return throwError(new ApiError(error.status, error.toString(), 'unknown'));
        }), catchError((error) => {
            if (error.code === 0 && firstCall) {
                return this.call(query, operationName, variables, ignoreStatus200Errors, cnsCall, false);
            }
            this.eventBus.emit(AMDOCS_CONSTANTS.API_ERROR_EVENT, error);
            return throwError(error);
        }));
    }
}
AmdocsAppsyncClientService.ɵfac = function AmdocsAppsyncClientService_Factory(t) { return new (t || AmdocsAppsyncClientService)(ɵɵinject(AmdocsCookieService), ɵɵinject(AmdocsApiUtilsService), ɵɵinject(HttpClient), ɵɵinject(AmdocsEventBusService), ɵɵinject('IAppSyncConfig')); };
AmdocsAppsyncClientService.ɵprov = ɵɵdefineInjectable({ token: AmdocsAppsyncClientService, factory: AmdocsAppsyncClientService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAppsyncClientService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AmdocsCookieService }, { type: AmdocsApiUtilsService }, { type: HttpClient }, { type: AmdocsEventBusService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['IAppSyncConfig']
            }] }]; }, null); })();

class AmdocsUserService {
    constructor(appSyncClient) {
        this.appSyncClient = appSyncClient;
    }
    init(initQuery = null, params = null) {
        if (!initQuery) {
            return of(this.user);
        }
        return this.appSyncClient.call(initQuery, this.appSyncClient.getConfig().initAppOperationName, params).pipe(mergeMap((response) => {
            this.setUserData(response);
            return of(this.user);
        }));
    }
    isLang(lang) {
        return this.user.lang === lang;
    }
    setUserData(initResponse) {
        this.user = {
            appSettings: initResponse.applicationInit.appSettings,
            userProfile: initResponse.applicationInit.userProfile,
            userSettings: initResponse.applicationInit.userSettings,
            employeeSearchHistory: initResponse.applicationInit.employeeSearchHistory,
            applicationShortcuts: initResponse.applicationInit.applicationShortcuts,
            applicationCards: initResponse.applicationInit.applicationCards,
        };
    }
    getUserShortName(userName = null) {
        var _a, _b;
        const name = userName || ((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.userProfile) === null || _b === void 0 ? void 0 : _b.name);
        if (!name) {
            return '';
        }
        const firstLetters = name.split(' ').map(value => value[0]);
        return firstLetters ? `${firstLetters[0]}${firstLetters[1] || ''}` : '';
    }
}
AmdocsUserService.ɵfac = function AmdocsUserService_Factory(t) { return new (t || AmdocsUserService)(ɵɵinject(AmdocsAppsyncClientService)); };
AmdocsUserService.ɵprov = ɵɵdefineInjectable({ token: AmdocsUserService, factory: AmdocsUserService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsUserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AmdocsAppsyncClientService }]; }, null); })();

class AmdocsAppInitService {
    constructor(deviceService, cookieService, translateService, authService, router, userService) {
        this.deviceService = deviceService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.authService = authService;
        this.router = router;
        this.userService = userService;
        this.appFinishedLoaded = false;
    }
    initApp(initQuery = null, setFixedHeightInMobile = true, redirectHomePostLogin = false) {
        if (setFixedHeightInMobile) {
            if (this.deviceService.isMobile()) {
                this.setAppHeights();
                window.addEventListener('resize', () => {
                    this.setAppHeights();
                });
            }
        }
        return this.initAppFlow(initQuery).pipe(finalize(() => {
            if (redirectHomePostLogin && this.isLoginCallback()) {
                this.router.navigate(['']);
            }
        }));
    }
    initAppFlow(initQuery = null) {
        if (this.isLoginCallback() && this.authService.isPkceValid()) {
            console.log('login callback');
            this.authService.removePkceExp();
            return this.authService.login(this.getLoginCallbackCode()).pipe(mergeMap(() => {
                console.log('login success');
                return this.initPostLogin(initQuery, true);
            }), catchError((error) => {
                console.log('login error');
                this.appInitError = error;
                return of(new AmdocsAppInitResponse(false, error));
            }));
        }
        else if (this.authService.isLoggedIn()) {
            return this.initPostLogin(initQuery);
        }
        else {
            if (this.authService.hasRefreshTokenCookies()) {
                console.log('refresh token exists');
                return this.authService.callRefreshUserToken().pipe(mergeMap(() => {
                    console.log('refresh token success');
                    return this.initPostLogin(initQuery);
                }), catchError(() => {
                    console.log('refresh token failed');
                    return this.initGetLoginUrlFlow();
                }));
            }
            else {
                console.log('refresh token does not exists');
                return this.initGetLoginUrlFlow();
            }
        }
    }
    initGetLoginUrlFlow() {
        return this.authService.initGetLoginUrlFlow().pipe(catchError((error) => {
            this.appInitError = error;
            return of(new AmdocsAppInitResponse(false, error));
        }));
    }
    setAppHeights() {
        if (!this.deviceService.screenHeight || window.innerHeight > this.deviceService.screenHeight) {
            this.deviceService.screenHeight = window.innerHeight;
        }
        // let h: number;
        // let w: number;
        // if (this.deviceService.isIos()) {
        //   h = window.innerHeight;
        //   w = window.innerWidth;
        // } else {
        //   h = window.screen.availHeight;
        //   w = window.screen.availWidth;
        // }
        // this.deviceService.portraitMode = h >= w;
        // if (!this.deviceService.portraitMode) {
        //   this.deviceService.screenHeight = window.innerHeight;
        // }
        document.body.style.height = this.deviceService.screenHeight + 'px';
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    // is route a callback from login
    isLoginCallback() {
        return window.location.href.indexOf('_callback') > -1;
    }
    // get login callback code
    getLoginCallbackCode() {
        return new URLSearchParams(window.location.search).get('code');
    }
    initPostLogin(initQuery = null, isPostLogin = false) {
        // use token expiration is less the 40 minutes
        if (this.authService.idTokenIsAboutToExpired()) {
            // make a call to refresh token and start the interval
            this.authService.refreshUserToken();
        }
        else {
            // only start the interval
            this.authService.setRefreshTokenInterval();
        }
        // init user details
        if (initQuery) {
            return this.userService.init(initQuery).pipe(mergeMap((user) => {
                return this.translateService.loadTranslate(user.lang).pipe(mergeMap(() => {
                    return of(new AmdocsAppInitResponse(true, null, isPostLogin));
                }));
            }), catchError((error) => {
                this.appInitError = error;
                return of(new AmdocsAppInitResponse(false, error, isPostLogin));
            }));
        }
        return of(new AmdocsAppInitResponse(true, null, isPostLogin));
    }
}
AmdocsAppInitService.ɵfac = function AmdocsAppInitService_Factory(t) { return new (t || AmdocsAppInitService)(ɵɵinject(AmdocsDeviceService), ɵɵinject(AmdocsCookieService), ɵɵinject(AmdocsTranslateService), ɵɵinject(AmdocsAuthService), ɵɵinject(Router), ɵɵinject(AmdocsUserService)); };
AmdocsAppInitService.ɵprov = ɵɵdefineInjectable({ token: AmdocsAppInitService, factory: AmdocsAppInitService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAppInitService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AmdocsDeviceService }, { type: AmdocsCookieService }, { type: AmdocsTranslateService }, { type: AmdocsAuthService }, { type: Router }, { type: AmdocsUserService }]; }, null); })();
class AmdocsAppInitResponse {
    constructor(success, error = null, isPostLogin = false) {
        this.success = success;
        this.error = error;
        this.isPostLogin = isPostLogin;
    }
}

class AmdocsAppErrorComponent {
    constructor(appInitService) {
        this.appInitService = appInitService;
    }
    ngOnInit() {
        if (this.errorMessage) {
            this.msg = this.errorMessage;
        }
        else if (this.appInitService.appInitError) {
            this.msg = this.appInitService.appInitError.message;
        }
        else {
            this.msg = "Something went wrong";
        }
    }
    reload() {
        window.location.reload();
    }
}
AmdocsAppErrorComponent.ɵfac = function AmdocsAppErrorComponent_Factory(t) { return new (t || AmdocsAppErrorComponent)(ɵɵdirectiveInject(AmdocsAppInitService)); };
AmdocsAppErrorComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsAppErrorComponent, selectors: [["lib-amdocs-app-error"]], inputs: { errorMessage: "errorMessage" }, decls: 7, vars: 1, consts: [["id", "app-error-wrapper", 1, "d-flex", "justify-content-center", "align-items-end"], [1, "error-content", "d-flex", "flex-column", "align-items-center", "justify-content-start"], [1, "error-msg"], [1, "error-btn"], [1, "btn", "btn-medium", "secondary", 3, "click"]], template: function AmdocsAppErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "button", 4);
        ɵɵlistener("click", function AmdocsAppErrorComponent_Template_button_click_5_listener() { return ctx.reload(); });
        ɵɵtext(6, "REFRESH");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.msg);
    } }, styles: ["#app-error-wrapper[_ngcontent-%COMP%]{background-image:url(/assets/images/error-bg.png);background-size:cover;height:100%}#app-error-wrapper[_ngcontent-%COMP%]   .error-content[_ngcontent-%COMP%]{margin-bottom:143px}#app-error-wrapper[_ngcontent-%COMP%]   .error-content[_ngcontent-%COMP%]   .error-msg[_ngcontent-%COMP%]{color:#fff;font-size:14px;font-weight:700;margin-bottom:24px;text-align:center}#app-error-wrapper[_ngcontent-%COMP%]   .error-content[_ngcontent-%COMP%]   .error-btn[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{background-color:#fff}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAppErrorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-app-error',
                templateUrl: './amdocs-app-error.component.html',
                styleUrls: ['./amdocs-app-error.component.scss']
            }]
    }], function () { return [{ type: AmdocsAppInitService }]; }, { errorMessage: [{
            type: Input
        }] }); })();

/**
 * example
 * {{'testTranslation' | amdocsTranslate:['p1', 'p2']}}
 */
class AmdocsTranslatePipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(value, args) {
        return this.translate.getText(value, args);
    }
}
AmdocsTranslatePipe.ɵfac = function AmdocsTranslatePipe_Factory(t) { return new (t || AmdocsTranslatePipe)(ɵɵdirectiveInject(AmdocsTranslateService)); };
AmdocsTranslatePipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsTranslate", type: AmdocsTranslatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTranslatePipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsTranslate'
            }]
    }], function () { return [{ type: AmdocsTranslateService }]; }, null); })();

class AmdocsPwaService {
    constructor() {
    }
    isPwa() {
        return checkIsPwa();
    }
}
AmdocsPwaService.ɵfac = function AmdocsPwaService_Factory(t) { return new (t || AmdocsPwaService)(); };
AmdocsPwaService.ɵprov = ɵɵdefineInjectable({ token: AmdocsPwaService, factory: AmdocsPwaService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPwaService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AmdocsSafeUrlPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(value) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
}
AmdocsSafeUrlPipe.ɵfac = function AmdocsSafeUrlPipe_Factory(t) { return new (t || AmdocsSafeUrlPipe)(ɵɵdirectiveInject(DomSanitizer)); };
AmdocsSafeUrlPipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsSafeUrl", type: AmdocsSafeUrlPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsSafeUrlPipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsSafeUrl'
            }]
    }], function () { return [{ type: DomSanitizer }]; }, null); })();

function AmdocsTopHeaderComponent_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "img", 7);
    ɵɵlistener("click", function AmdocsTopHeaderComponent_img_1_Template_img_click_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.handleBackButtonClicked(); });
    ɵɵelementEnd();
} }
function AmdocsTopHeaderComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 8);
} }
function AmdocsTopHeaderComponent_span_5_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 12);
    ɵɵpipe(1, "amdocsSafeUrl");
} if (rf & 2) {
    const headerAction_r6 = ɵɵnextContext().$implicit;
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, headerAction_r6.innerHtml), ɵɵsanitizeHtml);
} }
function AmdocsTopHeaderComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 9);
    ɵɵelementStart(1, "img", 10);
    ɵɵlistener("click", function AmdocsTopHeaderComponent_span_5_Template_img_click_1_listener() { ɵɵrestoreView(_r10); const headerAction_r6 = ctx.$implicit; const ctx_r9 = ɵɵnextContext(); return ctx_r9.onActionClick(headerAction_r6); });
    ɵɵelementEnd();
    ɵɵtemplate(2, AmdocsTopHeaderComponent_span_5_span_2_Template, 2, 3, "span", 11);
    ɵɵelementEnd();
} if (rf & 2) {
    const headerAction_r6 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵstyleProp("width", headerAction_r6.width, "px")("height", headerAction_r6.height, "px");
    ɵɵproperty("src", headerAction_r6.iconPath, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", headerAction_r6.innerHtml);
} }
function AmdocsTopHeaderComponent_img_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "img", 13);
    ɵɵlistener("click", function AmdocsTopHeaderComponent_img_7_Template_img_click_0_listener() { ɵɵrestoreView(_r12); const ctx_r11 = ɵɵnextContext(); return ctx_r11.backHome(); });
    ɵɵelementEnd();
} }
class AmdocsTopHeaderComponent {
    constructor(location, router, functionsService, pwaService) {
        this.location = location;
        this.router = router;
        this.functionsService = functionsService;
        this.pwaService = pwaService;
        this.showBackBtn = true;
        this.showHomeButton = false;
        this.headerActions = [];
        this.urlRedirectHome = '';
        this.onBackButtonClickCb = new EventEmitter();
    }
    ngOnInit() {
    }
    handleBackButtonClicked() {
        if (this.onBackButtonClickCb.observers.length) {
            this.onBackButtonClickCb.emit();
        }
        else {
            this.location.back();
        }
    }
    backHome() {
        if (!!this.urlRedirectHome) {
            if (this.pwaService.isPwa()) {
                window.close();
            }
            else {
                this.functionsService.navigateExternalUrl(this.urlRedirectHome, '_self');
            }
        }
        else {
            this.router.navigate(['']);
        }
    }
    onActionClick(headerAction) {
        if (headerAction.action) {
            headerAction.action();
        }
    }
}
AmdocsTopHeaderComponent.ɵfac = function AmdocsTopHeaderComponent_Factory(t) { return new (t || AmdocsTopHeaderComponent)(ɵɵdirectiveInject(Location), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AmdocsFunctionsService), ɵɵdirectiveInject(AmdocsPwaService)); };
AmdocsTopHeaderComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTopHeaderComponent, selectors: [["lib-amdocs-top-header"]], inputs: { headerTitle: "headerTitle", showBackBtn: "showBackBtn", showHomeButton: "showHomeButton", headerActions: "headerActions", urlRedirectHome: "urlRedirectHome" }, outputs: { onBackButtonClickCb: "onBackButtonClickCb" }, decls: 8, vars: 6, consts: [[1, "top-header-main-wrapper"], ["alt", "", "src", "/assets/icons/arrow-left.svg", 3, "click", 4, "ngIf"], ["aria-hidden", "true", "class", "reserved-for-img", 4, "ngIf"], [1, "text-medium-bold", "title-text"], ["aria-hidden", "true", "class", "reserved-for-img header-action", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "reserved-for-img", 3, "hidden"], ["alt", "", "src", "/assets/icons/home.svg", 3, "click", 4, "ngIf"], ["alt", "", "src", "/assets/icons/arrow-left.svg", 3, "click"], ["aria-hidden", "true", 1, "reserved-for-img"], ["aria-hidden", "true", 1, "reserved-for-img", "header-action"], ["alt", "", 3, "src", "click"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], ["alt", "", "src", "/assets/icons/home.svg", 3, "click"]], template: function AmdocsTopHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AmdocsTopHeaderComponent_img_1_Template, 1, 0, "img", 1);
        ɵɵtemplate(2, AmdocsTopHeaderComponent_span_2_Template, 1, 0, "span", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵtemplate(5, AmdocsTopHeaderComponent_span_5_Template, 3, 6, "span", 4);
        ɵɵelementStart(6, "span", 5);
        ɵɵtemplate(7, AmdocsTopHeaderComponent_img_7_Template, 1, 0, "img", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showBackBtn);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.showBackBtn);
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ctx.headerTitle, " ");
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.headerActions);
        ɵɵadvance(1);
        ɵɵproperty("hidden", !ctx.showHomeButton && ctx.headerActions.length > 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showHomeButton);
    } }, directives: [NgIf, NgForOf], pipes: [AmdocsSafeUrlPipe], styles: [".top-header-main-wrapper[_ngcontent-%COMP%]{align-items:center;background-color:#22212e;border-bottom:1px solid #343647;display:flex;height:56px;justify-content:center;padding:0 20px;position:relative}.top-header-main-wrapper[_ngcontent-%COMP%]   .title-text[_ngcontent-%COMP%]{color:#fff;flex-grow:1;margin:0 8px;text-align:center}.top-header-main-wrapper[_ngcontent-%COMP%]   .title-text[_ngcontent-%COMP%]:first-child{margin-left:0}.top-header-main-wrapper[_ngcontent-%COMP%]   .reserved-for-img[_ngcontent-%COMP%], .top-header-main-wrapper[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:24px;margin:0 8px;width:24px}.top-header-main-wrapper[_ngcontent-%COMP%]   .reserved-for-img[_ngcontent-%COMP%]:first-child, .top-header-main-wrapper[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]:first-child{margin-left:0}.top-header-main-wrapper[_ngcontent-%COMP%]   .reserved-for-img[_ngcontent-%COMP%]:last-child, .top-header-main-wrapper[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]:last-child{margin-right:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTopHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-top-header',
                templateUrl: './amdocs-top-header.component.html',
                styleUrls: ['./amdocs-top-header.component.scss']
            }]
    }], function () { return [{ type: Location }, { type: Router }, { type: AmdocsFunctionsService }, { type: AmdocsPwaService }]; }, { headerTitle: [{
            type: Input
        }], showBackBtn: [{
            type: Input
        }], showHomeButton: [{
            type: Input
        }], headerActions: [{
            type: Input
        }], urlRedirectHome: [{
            type: Input
        }], onBackButtonClickCb: [{
            type: Output
        }] }); })();

function AmdocsPopupMessageComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 7);
    ɵɵlistener("click", function AmdocsPopupMessageComponent_div_9_Template_div_click_0_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.home(); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.homeButtonText);
} }
const _c0$3 = function (a0) { return { "with-margin": a0 }; };
class AmdocsPopupMessageComponent {
    constructor(router) {
        this.router = router;
        this.reloadButtonText = 'RELOAD';
        this.homeButtonText = 'Back home';
        this.showHomeButton = true;
        this.actionClicked = new EventEmitter();
    }
    ngOnInit() {
    }
    reload() {
        this.actionClicked.emit();
        window.location.reload();
    }
    home() {
        this.actionClicked.emit();
        if (this.homeNavigation) {
            this.router.navigate([this.homeNavigation]);
        }
        else {
            this.router.navigate(['']);
        }
    }
}
AmdocsPopupMessageComponent.ɵfac = function AmdocsPopupMessageComponent_Factory(t) { return new (t || AmdocsPopupMessageComponent)(ɵɵdirectiveInject(Router)); };
AmdocsPopupMessageComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsPopupMessageComponent, selectors: [["lib-amdocs-popup-message"]], inputs: { title: "title", message: "message", reloadButtonText: "reloadButtonText", homeButtonText: "homeButtonText", showHomeButton: "showHomeButton", homeNavigation: "homeNavigation" }, outputs: { actionClicked: "actionClicked" }, decls: 10, vars: 7, consts: [[1, "message-popup-content"], [1, "top", "text-center"], [1, "title", "label-h4"], [1, "message", "text-small-normal"], [1, "buttons-wrapper", "d-flex", "flex-column", "align-items-center", "justify-content-start"], [1, "btn", "btn-tiny", "primary", 3, "ngClass", "click"], ["role", "button", "class", "text-small-normal back-button", 3, "click", 4, "ngIf"], ["role", "button", 1, "text-small-normal", "back-button", 3, "click"]], template: function AmdocsPopupMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 3);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 4);
        ɵɵelementStart(7, "button", 5);
        ɵɵlistener("click", function AmdocsPopupMessageComponent_Template_button_click_7_listener() { return ctx.reload(); });
        ɵɵtext(8);
        ɵɵelementEnd();
        ɵɵtemplate(9, AmdocsPopupMessageComponent_div_9_Template, 2, 1, "div", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.title);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.message);
        ɵɵadvance(2);
        ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c0$3, ctx.showHomeButton));
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.reloadButtonText);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showHomeButton);
    } }, directives: [NgClass, NgIf], styles: [".message-popup-content[_ngcontent-%COMP%]{color:#22212e;padding:0 36px}.message-popup-content[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:8px}.message-popup-content[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin-bottom:24px}.message-popup-content[_ngcontent-%COMP%]   .buttons-wrapper[_ngcontent-%COMP%]   .with-margin[_ngcontent-%COMP%]{margin-bottom:12px}.message-popup-content[_ngcontent-%COMP%]   .buttons-wrapper[_ngcontent-%COMP%]   .back-button[_ngcontent-%COMP%]{color:#22212e}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPopupMessageComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-popup-message',
                templateUrl: './amdocs-popup-message.component.html',
                styleUrls: ['./amdocs-popup-message.component.scss']
            }]
    }], function () { return [{ type: Router }]; }, { title: [{
            type: Input
        }], message: [{
            type: Input
        }], reloadButtonText: [{
            type: Input
        }], homeButtonText: [{
            type: Input
        }], showHomeButton: [{
            type: Input
        }], homeNavigation: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }] }); })();

const _c0$4 = function (a0, a1, a2) { return { "text-small-bold": a0, "text-small-normal": a1, "disabled": a2 }; };
const _c1$2 = function (a0) { return { "selected": a0 }; };
function AmdocsRadioComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "label", 1);
    ɵɵelementStart(2, "span", 2);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "input", 3);
    ɵɵlistener("change", function AmdocsRadioComponent_ng_container_1_Template_input_change_4_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.onChange(); });
    ɵɵelementEnd();
    ɵɵelement(5, "span", 4);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction3(6, _c0$4, ctx_r0.control.value === item_r1.id, ctx_r0.control.value !== item_r1.id, ctx_r0.isDisabled()));
    ɵɵadvance(1);
    ɵɵtextInterpolate(item_r1.desc);
    ɵɵadvance(1);
    ɵɵproperty("value", item_r1.id)("formControl", ctx_r0.control);
    ɵɵattribute("disabled", ctx_r0.isDisabled() ? ctx_r0.isDisabled() : null);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c1$2, ctx_r0.control.value === item_r1.id));
} }
class AmdocsRadioComponent extends AmdocsControlAbstract {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
AmdocsRadioComponent.ɵfac = function AmdocsRadioComponent_Factory(t) { return ɵAmdocsRadioComponent_BaseFactory(t || AmdocsRadioComponent); };
AmdocsRadioComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsRadioComponent, selectors: [["lib-amdocs-radio"]], inputs: { options: "options" }, features: [ɵɵInheritDefinitionFeature], decls: 2, vars: 4, consts: [[4, "ngFor", "ngForOf"], [1, "container"], [3, "ngClass"], ["type", "radio", 1, "hidden-input", 3, "value", "formControl", "change"], [1, "custom-control-indicator", 3, "ngClass"]], template: function AmdocsRadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵtemplate(1, AmdocsRadioComponent_ng_container_1_Template, 6, 12, "ng-container", 0);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("amdocs-form-radio ", ctx.customClass, "");
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [NgForOf, NgClass, RadioControlValueAccessor, DefaultValueAccessor, NgControlStatus, FormControlDirective], styles: [".amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{-ms-user-select:none;-webkit-user-select:none;align-items:center;cursor:pointer;display:flex;height:24px;margin-bottom:8px;padding-left:35px;position:relative;user-select:none}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer;opacity:0;position:absolute}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .custom-control-indicator.selected[_ngcontent-%COMP%]{opacity:1}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .custom-control-indicator.selected[_ngcontent-%COMP%]:after{background-color:#22212e;height:12px;width:12px}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled ~ .custom-control-indicator[_ngcontent-%COMP%]{border-color:#e8e9ed;opacity:1}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled ~ .custom-control-indicator[_ngcontent-%COMP%]:after{background-color:#c9c9d3}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]{background-color:#f1f1f4;border:2px solid #22212e;border-radius:50%;height:24px;left:0;opacity:.5;position:absolute;top:0;width:24px}.amdocs-form-radio[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]:after{background:#22212e;border-radius:50%;content:\"\";height:0;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);transition:.25s ease-in-out;width:0}"] });
const ɵAmdocsRadioComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsRadioComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsRadioComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-radio',
                templateUrl: './amdocs-radio.component.html',
                styleUrls: ['./amdocs-radio.component.scss']
            }]
    }], null, { options: [{
            type: Input
        }] }); })();

const _c0$5 = ["inputRef"];
function AmdocsInputFieldComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 5);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.label);
} }
function AmdocsInputFieldComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 6);
    ɵɵelement(1, "img", 7);
    ɵɵelementStart(2, "span", 8);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ctx_r2.getErrorMsg(), " ");
} }
class AmdocsInputFieldComponent extends AmdocsControlAbstract {
    ngOnInit() {
        super.ngOnInit();
    }
    setFocus() {
        this.inputRef.nativeElement.focus();
    }
    get value() {
        if (!this.timeInput) {
            return this.control.value;
        }
        if (!this.control.value) {
            return '';
        }
        if (this.control.value.toString().length >= 3) {
            return this.control.value.toString().slice(0, 2) + ':' + this.control.value.toString().slice(2);
        }
        return this.control.value;
    }
    set value(val) {
        if (this.timeInput) {
            this.control.setValue(val.toString().replace(':', ''));
            return;
        }
        this.control.setValue(val);
    }
    handlePaste(event) {
        if (this.preventPaste) {
            event.preventDefault();
        }
    }
}
AmdocsInputFieldComponent.ɵfac = function AmdocsInputFieldComponent_Factory(t) { return ɵAmdocsInputFieldComponent_BaseFactory(t || AmdocsInputFieldComponent); };
AmdocsInputFieldComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsInputFieldComponent, selectors: [["lib-amdocs-input-field"]], viewQuery: function AmdocsInputFieldComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$5, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.inputRef = _t.first);
    } }, inputs: { timeInput: "timeInput", preventPaste: "preventPaste" }, features: [ɵɵInheritDefinitionFeature], decls: 5, vars: 16, consts: [[1, "custom-input-field"], ["class", "custom-input-label", 4, "ngIf"], [1, "custom-input-field-control", "full-width", 3, "id", "placeholder", "ngModel", "maxlength", "ngModelChange", "focus", "blur", "keydown", "keyup", "paste"], ["inputRef", ""], ["class", "custom-input-field-error", 4, "ngIf"], [1, "custom-input-label"], [1, "custom-input-field-error"], ["src", "/assets/icons/error.svg"], [1, "text-small-normal"]], template: function AmdocsInputFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AmdocsInputFieldComponent_label_1_Template, 2, 1, "label", 1);
        ɵɵelementStart(2, "input", 2, 3);
        ɵɵlistener("ngModelChange", function AmdocsInputFieldComponent_Template_input_ngModelChange_2_listener($event) { return ctx.value = $event; })("focus", function AmdocsInputFieldComponent_Template_input_focus_2_listener() { return ctx.onFocus(); })("blur", function AmdocsInputFieldComponent_Template_input_blur_2_listener() { return ctx.onBlur(); })("keydown", function AmdocsInputFieldComponent_Template_input_keydown_2_listener($event) { return ctx.onKeyDown($event); })("keyup", function AmdocsInputFieldComponent_Template_input_keyup_2_listener($event) { return ctx.onKeyUp($event); })("paste", function AmdocsInputFieldComponent_Template_input_paste_2_listener($event) { return ctx.handlePaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, AmdocsInputFieldComponent_div_4_Template, 4, 1, "div", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.hideLabel);
        ɵɵadvance(1);
        ɵɵclassProp("active", ctx.control.value)("invalid", ctx.isInvalid())("text-center", ctx.textCenter)("readonly", ctx.readOnly);
        ɵɵproperty("id", ctx.elementId)("placeholder", ctx.placeHolder)("ngModel", ctx.value)("maxlength", ctx.inputMaxLength);
        ɵɵattribute("disabled", ctx.isDisabled() ? ctx.isDisabled() : null)("inputmode", ctx.inputMode);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.isInvalid() && ctx.showValidationErrorText);
    } }, directives: [NgIf, DefaultValueAccessor, NgControlStatus, NgModel, MaxLengthValidator], styles: [""] });
const ɵAmdocsInputFieldComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsInputFieldComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsInputFieldComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-input-field',
                templateUrl: './amdocs-input-field.component.html',
                styleUrls: ['./amdocs-input-field.component.scss']
            }]
    }], null, { timeInput: [{
            type: Input
        }], preventPaste: [{
            type: Input
        }], inputRef: [{
            type: ViewChild,
            args: ['inputRef']
        }] }); })();

function AmdocsLargeTextInputComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 4);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.label);
} }
function AmdocsLargeTextInputComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 5);
    ɵɵelement(1, "img", 6);
    ɵɵelementStart(2, "span", 7);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ctx_r1.getErrorMsg(), " ");
} }
class AmdocsLargeTextInputComponent extends AmdocsControlAbstract {
    constructor() {
        super(...arguments);
        this.maxContent = null;
    }
    ngOnInit() {
        super.ngOnInit();
        this.checkMaxWidth();
    }
    checkMaxWidth() {
        if (!this.inputMaxLength) {
            this.maxContent = 'fit-content';
        }
    }
}
AmdocsLargeTextInputComponent.ɵfac = function AmdocsLargeTextInputComponent_Factory(t) { return ɵAmdocsLargeTextInputComponent_BaseFactory(t || AmdocsLargeTextInputComponent); };
AmdocsLargeTextInputComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsLargeTextInputComponent, selectors: [["lib-amdocs-large-text-input"]], features: [ɵɵInheritDefinitionFeature], decls: 5, vars: 16, consts: [[1, "custom-input-field"], ["class", "custom-input-label", 4, "ngIf"], [1, "custom-input-field-control", "large-input", 3, "ngClass", "id", "formControl", "placeholder", "value", "focus", "blur", "keydown", "keyup"], ["class", "custom-input-field-error", 4, "ngIf"], [1, "custom-input-label"], [1, "custom-input-field-error"], ["src", "/assets/icons/error.svg"], [1, "text-small-normal"]], template: function AmdocsLargeTextInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AmdocsLargeTextInputComponent_label_1_Template, 2, 1, "label", 1);
        ɵɵelementStart(2, "textarea", 2);
        ɵɵlistener("focus", function AmdocsLargeTextInputComponent_Template_textarea_focus_2_listener() { return ctx.onFocus(); })("blur", function AmdocsLargeTextInputComponent_Template_textarea_blur_2_listener() { return ctx.onBlur(); })("keydown", function AmdocsLargeTextInputComponent_Template_textarea_keydown_2_listener($event) { return ctx.onKeyDown($event); })("keyup", function AmdocsLargeTextInputComponent_Template_textarea_keyup_2_listener($event) { return ctx.onKeyUp($event); });
        ɵɵtext(3, "\n");
        ɵɵelementEnd();
        ɵɵtemplate(4, AmdocsLargeTextInputComponent_div_4_Template, 4, 1, "div", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.hideLabel);
        ɵɵadvance(1);
        ɵɵclassProp("active", ctx.control.value)("invalid", ctx.isInvalid())("readonly", ctx.readOnly);
        ɵɵproperty("ngClass", ctx.maxContent)("id", ctx.elementId)("formControl", ctx.control)("placeholder", ctx.placeHolder)("value", ctx.control.value);
        ɵɵattribute("maxLength", ctx.inputMaxLength)("disabled", ctx.isDisabled() ? ctx.isDisabled() : null)("inputmode", ctx.inputMode);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.isInvalid() && ctx.showValidationErrorText);
    } }, directives: [NgIf, DefaultValueAccessor, NgClass, NgControlStatus, FormControlDirective], styles: ["textarea.fit-content[_ngcontent-%COMP%]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}"] });
const ɵAmdocsLargeTextInputComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsLargeTextInputComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsLargeTextInputComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-large-text-input',
                templateUrl: './amdocs-large-text-input.component.html',
                styleUrls: ['./amdocs-large-text-input.component.scss']
            }]
    }], null, null); })();

const _c0$6 = ["swiperContentItem"];
const _c1$3 = ["swiperComp"];
function AmdocsSwiperComponent_ng_container_2_ng_template_1_ng_template_0_Template(rf, ctx) { }
const _c2$1 = function (a0) { return [a0]; };
function AmdocsSwiperComponent_ng_container_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, AmdocsSwiperComponent_ng_container_2_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 4);
} if (rf & 2) {
    const item_r2 = ɵɵnextContext().$implicit;
    const ctx_r3 = ɵɵnextContext();
    ɵɵproperty("ngForOf", ɵɵpureFunction1(2, _c2$1, item_r2))("ngForTemplate", ctx_r3.swiperContentItem);
} }
function AmdocsSwiperComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsSwiperComponent_ng_container_2_ng_template_1_Template, 1, 4, "ng-template", 3);
    ɵɵelementContainerEnd();
} }
const _c3$1 = function () { return { clickable: true }; };
SwiperCore.use([Pagination]);
/**
 * @example
 *  <lib-amdocs-swiper>
 *    <ng-template let-item="MY_ITEMS" #swiperContentItem>
 *      <div class="slide-wrapper" (click)="onItemClick(item)">
 *        <img src="SRC">
 *        <div class="section text-tiny-normal text-color-secondary">DATE</div>
 *        <div class="section text-medium-bold"> TITLE</div>
 *        <div class="section text-small-normal"> TEXT</div>
 *      </div>
 *    </ng-template>
 *  </lib-amdocs-swiper>
 *
 * */
class AmdocsSwiperComponent {
    constructor() {
        this.slidePerView = 1;
        this.spaceBetween = 50;
        this.loopMode = true;
        this.items = [];
        this.onSwipe = new EventEmitter();
        this.onChange = new EventEmitter();
        this.currentItem = 0;
    }
    ngOnInit() {
    }
    onSwiper(ev) {
        this.onSwipe.emit(ev);
        this.setCurrentItem(ev.activeIndex);
    }
    onSlideChange() {
        this.onChange.emit();
    }
    onActiveItemChanged(ev) {
        this.setCurrentItem(ev.activeIndex);
    }
    setCurrentItem(index) {
        this.currentItem = (index % this.items.length || this.items.length) - 1;
    }
    next() {
        if (this.currentItem + 1 !== this.items.length) {
            this.swiperComp.setIndex(this.currentItem + 1);
        }
    }
    prev() {
        if (this.currentItem - 1 >= 0) {
            this.swiperComp.setIndex(this.currentItem - 1);
        }
    }
    setIndex(index) {
        if ((index + 1 !== this.items.length) && (index - 1) >= 0) {
            this.swiperComp.setIndex(index);
        }
    }
}
AmdocsSwiperComponent.ɵfac = function AmdocsSwiperComponent_Factory(t) { return new (t || AmdocsSwiperComponent)(); };
AmdocsSwiperComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsSwiperComponent, selectors: [["lib-amdocs-swiper"]], contentQueries: function AmdocsSwiperComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, _c0$6, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.swiperContentItem = _t.first);
    } }, viewQuery: function AmdocsSwiperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c1$3, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.swiperComp = _t.first);
    } }, inputs: { slidePerView: "slidePerView", spaceBetween: "spaceBetween", loopMode: "loopMode", items: "items" }, outputs: { onSwipe: "onSwipe", onChange: "onChange" }, decls: 3, vars: 6, consts: [[3, "slidesPerView", "spaceBetween", "loop", "pagination", "swiper", "activeIndexChange", "slideChange"], ["swiperComp", ""], [4, "ngFor", "ngForOf"], ["swiperSlide", ""], ["ngFor", "", 3, "ngForOf", "ngForTemplate"]], template: function AmdocsSwiperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "swiper", 0, 1);
        ɵɵlistener("swiper", function AmdocsSwiperComponent_Template_swiper_swiper_0_listener($event) { return ctx.onSwiper($event); })("activeIndexChange", function AmdocsSwiperComponent_Template_swiper_activeIndexChange_0_listener($event) { return ctx.onActiveItemChanged($event); })("slideChange", function AmdocsSwiperComponent_Template_swiper_slideChange_0_listener() { return ctx.onSlideChange(); });
        ɵɵtemplate(2, AmdocsSwiperComponent_ng_container_2_Template, 2, 0, "ng-container", 2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("slidesPerView", ctx.slidePerView)("spaceBetween", ctx.spaceBetween)("loop", ctx.loopMode)("pagination", ɵɵpureFunction0(5, _c3$1));
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [SwiperComponent, NgForOf, SwiperSlideDirective], styles: [".swiper-pagination-clickable{align-items:center;border-top:1px solid #f1f1f4;display:flex;justify-content:center;padding-top:12px}  .swiper-pagination-clickable .swiper-pagination-bullet{background:#82889c;box-sizing:border-box;height:4px;width:4px}  .swiper-pagination-clickable .swiper-pagination-bullet.swiper-pagination-bullet-active{background:#f1f1f4;border:1px solid #22212e;height:6px;width:6px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsSwiperComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-swiper',
                templateUrl: './amdocs-swiper.component.html',
                styleUrls: ['./amdocs-swiper.component.scss']
            }]
    }], function () { return []; }, { swiperComp: [{
            type: ViewChild,
            args: ['swiperComp']
        }], slidePerView: [{
            type: Input
        }], spaceBetween: [{
            type: Input
        }], loopMode: [{
            type: Input
        }], items: [{
            type: Input
        }], onSwipe: [{
            type: Output
        }], onChange: [{
            type: Output
        }], swiperContentItem: [{
            type: ContentChild,
            args: ['swiperContentItem']
        }] }); })();

function AmdocsAppLoaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 2);
} }
class AmdocsAppLoaderComponent {
    constructor() {
    }
}
AmdocsAppLoaderComponent.ɵfac = function AmdocsAppLoaderComponent_Factory(t) { return new (t || AmdocsAppLoaderComponent)(); };
AmdocsAppLoaderComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsAppLoaderComponent, selectors: [["lib-amdocs-app-loader"]], inputs: { showOverlay: "showOverlay" }, decls: 7, vars: 1, consts: [["class", "overlay", 4, "ngIf"], [1, "lds-roller"], [1, "overlay"]], template: function AmdocsAppLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsAppLoaderComponent_div_0_Template, 1, 0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "div");
        ɵɵelement(3, "div");
        ɵɵelement(4, "div");
        ɵɵelement(5, "div");
        ɵɵelement(6, "div");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showOverlay);
    } }, directives: [NgIf], styles: [".overlay[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.4);bottom:0;cursor:none;height:100%;left:0;position:fixed;right:0;top:0;width:100%;z-index:10}.lds-roller[_ngcontent-%COMP%]{background-color:#22212e;border-radius:50px;display:inline-block;height:64px;left:calc(50% - 32px);opacity:.6;position:fixed;top:calc(50% - 32px);width:64px;z-index:11}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{animation:lds-roller 1.2s cubic-bezier(.5,0,.5,1) infinite;transform-origin:32px 32px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:after{background:#f6e8e8;border-radius:50%;content:\" \";display:block;height:6px;margin:-3px 0 0 -3px;position:absolute;width:6px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{animation-delay:-36ms}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child:after{height:2px;left:50px;top:45px;width:2px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){animation-delay:-72ms}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2):after{height:3px;left:45px;top:54px;width:3px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(3){animation-delay:-.144s}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(3):after{height:5px;left:32px;top:58px;width:5px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(4){animation-delay:-.216s}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(4):after{height:7px;left:19px;top:54px;width:7px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(5){animation-delay:-.252s}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(5):after{height:8px;left:10px;top:45px;width:8px}.lds-roller[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(6){animation-delay:-.288s}@keyframes lds-roller{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAppLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-app-loader',
                templateUrl: './amdocs-app-loader.component.html',
                styleUrls: ['./amdocs-app-loader.component.scss']
            }]
    }], function () { return []; }, { showOverlay: [{
            type: Input
        }] }); })();

/**
 * example
 * {{'testTranslation' | AmdocsTruncatePipe: LIMIT : COMPLELTE : ELLIPSIS}}
 */
class AmdocsTruncatePipe {
    constructor() { }
    transform(value, limit = 25, completeWords = false, ellipsis = '...') {
        if (completeWords) {
            limit = value.substr(0, limit).lastIndexOf(' ');
        }
        return value.length > limit ? value.substr(0, limit) + ellipsis : value;
    }
}
AmdocsTruncatePipe.ɵfac = function AmdocsTruncatePipe_Factory(t) { return new (t || AmdocsTruncatePipe)(); };
AmdocsTruncatePipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsTruncate", type: AmdocsTruncatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTruncatePipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsTruncate'
            }]
    }], function () { return []; }, null); })();

/**
 * @description
 * Amdocs click outside directive - emit a callback function once the user click outside the element
 *
 * @example
 * <div lib-amdocs-click-outside (clickOutside)="myFunc()">Some content</div>
 *
 */
class AmdocsClickOutsideDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new EventEmitter();
    }
    onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
}
AmdocsClickOutsideDirective.ɵfac = function AmdocsClickOutsideDirective_Factory(t) { return new (t || AmdocsClickOutsideDirective)(ɵɵdirectiveInject(ElementRef)); };
AmdocsClickOutsideDirective.ɵdir = ɵɵdefineDirective({ type: AmdocsClickOutsideDirective, selectors: [["", "lib-amdocs-click-outside", ""]], hostBindings: function AmdocsClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("touchend", function AmdocsClickOutsideDirective_touchend_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, ɵɵresolveDocument)("click", function AmdocsClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsClickOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[lib-amdocs-click-outside]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:touchend', ['$event.target']]
        }, {
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

/**
 * example
 * {{'value' | amdocsDynamicPipe: YOUR_PIPS}}
 */
class AmdocsDynamicPipe {
    constructor(injector) {
        this.injector = injector;
    }
    transform(value, pipeToken, pipeArgs = []) {
        if (!pipeToken) {
            return value;
        }
        else {
            const pipe = this.injector.get(pipeToken);
            return pipe.transform(value, ...pipeArgs);
        }
    }
}
AmdocsDynamicPipe.ɵfac = function AmdocsDynamicPipe_Factory(t) { return new (t || AmdocsDynamicPipe)(ɵɵdirectiveInject(Injector)); };
AmdocsDynamicPipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsDynamicPipe", type: AmdocsDynamicPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsDynamicPipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsDynamicPipe'
            }]
    }], function () { return [{ type: Injector }]; }, null); })();

class AmdocsTimeColonFormatPipe {
    transform(value, args) {
        let _value = value || 0;
        // return NULL if needed for no value
        if (!_value) {
            return null;
        }
        if (_value.length <= 2) {
            return _value;
        }
        _value = _value.toString().replace(':', '');
        let hours;
        let min;
        if (_value.length === 3) {
            hours = _value.substring(0, 2);
            min = _value.substring(2, 3);
        }
        else {
            hours = _value.substring(0, 2);
            min = _value.substring(2, 4);
        }
        return `${hours}:${min}`;
    }
}
AmdocsTimeColonFormatPipe.ɵfac = function AmdocsTimeColonFormatPipe_Factory(t) { return new (t || AmdocsTimeColonFormatPipe)(); };
AmdocsTimeColonFormatPipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsTimeColonFormat", type: AmdocsTimeColonFormatPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTimeColonFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsTimeColonFormat'
            }]
    }], null, null); })();

const _c0$7 = function (a0) { return { "show": a0 }; };
function AmdocsUserNotifyAlertComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c0$7, ctx_r0.show));
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.saveMsgText);
} }
class AmdocsUserNotifyAlertComponent {
    constructor() {
        this.duration = 3000;
        this.show = false;
        this.displaySaveAlert = false;
    }
    showMessage(text) {
        this.saveMsgText = text;
        this.displaySaveAlert = true;
        setTimeout(() => {
            this.show = true;
            setTimeout(() => {
                this.show = false;
                setTimeout(() => {
                    this.displaySaveAlert = false;
                }, 1000);
            }, this.duration);
        }, 10);
    }
}
AmdocsUserNotifyAlertComponent.ɵfac = function AmdocsUserNotifyAlertComponent_Factory(t) { return new (t || AmdocsUserNotifyAlertComponent)(); };
AmdocsUserNotifyAlertComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsUserNotifyAlertComponent, selectors: [["lib-amdocs-user-notify-alert"]], inputs: { duration: "duration" }, decls: 1, vars: 1, consts: [["class", "amdocs-user-notify-alert-wrapper", 3, "ngClass", 4, "ngIf"], [1, "amdocs-user-notify-alert-wrapper", 3, "ngClass"], [1, "amdocs-user-notify-alert-text", "text-medium-bold"]], template: function AmdocsUserNotifyAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsUserNotifyAlertComponent_div_0_Template, 3, 4, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.displaySaveAlert);
    } }, directives: [NgIf, NgClass], styles: [".amdocs-user-notify-alert-wrapper[_ngcontent-%COMP%]{align-items:center;display:flex;height:100%;justify-content:center;left:0;opacity:0;position:fixed;top:0;transition:opacity 1s ease-in-out;width:100%}.amdocs-user-notify-alert-wrapper.show[_ngcontent-%COMP%]{opacity:1}.amdocs-user-notify-alert-wrapper[_ngcontent-%COMP%]   .amdocs-user-notify-alert-text[_ngcontent-%COMP%]{background-color:#82889c;border-radius:28px;color:#fff;padding:20px 27px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsUserNotifyAlertComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-user-notify-alert',
                templateUrl: './amdocs-user-notify-alert.component.html',
                styleUrls: ['./amdocs-user-notify-alert.component.scss']
            }]
    }], function () { return []; }, { duration: [{
            type: Input
        }] }); })();

class AmdocsLandscapeViewComponent {
    constructor() {
        this.title = 'Please rotate your Phone';
        this.description = 'We support portrait mode only';
    }
}
AmdocsLandscapeViewComponent.ɵfac = function AmdocsLandscapeViewComponent_Factory(t) { return new (t || AmdocsLandscapeViewComponent)(); };
AmdocsLandscapeViewComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsLandscapeViewComponent, selectors: [["lib-amdocs-landscape-view"]], inputs: { title: "title", description: "description" }, decls: 7, vars: 2, consts: [[1, "landscape-wrapper"], ["src", "/assets/images/landscape.svg"], [1, "label-h1"], [1, "text-small-normal"]], template: function AmdocsLandscapeViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "img", 1);
        ɵɵelementStart(2, "div");
        ɵɵelementStart(3, "div", 2);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 3);
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵtextInterpolate(ctx.title);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.description);
    } }, styles: [".landscape-wrapper[_ngcontent-%COMP%]{align-items:center;color:#22212e;display:flex;height:100%;justify-content:space-around;left:0;position:fixed;top:0;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsLandscapeViewComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-landscape-view',
                templateUrl: './amdocs-landscape-view.component.html',
                styleUrls: ['./amdocs-landscape-view.component.scss']
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], description: [{
            type: Input
        }] }); })();

function AmdocsPwaIosNotificationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 1);
    ɵɵlistener("clickOutside", function AmdocsPwaIosNotificationComponent_div_0_Template_div_clickOutside_0_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.closeProgressiveWebAppNotification(); });
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "button", 3);
    ɵɵlistener("click", function AmdocsPwaIosNotificationComponent_div_0_Template_button_click_2_listener() { ɵɵrestoreView(_r2); const ctx_r3 = ɵɵnextContext(); return ctx_r3.closeButtonClicked(); });
    ɵɵelement(3, "img", 4);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 5);
    ɵɵelementStart(5, "div", 6);
    ɵɵelement(6, "img", 7);
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 8);
    ɵɵelementStart(8, "div");
    ɵɵelementStart(9, "span");
    ɵɵtext(10);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "div");
    ɵɵelementStart(12, "span");
    ɵɵtext(13, "tap");
    ɵɵelementEnd();
    ɵɵelementStart(14, "span");
    ɵɵelement(15, "img", 9);
    ɵɵelementEnd();
    ɵɵelementStart(16, "span");
    ɵɵtext(17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(10);
    ɵɵtextInterpolate(ctx_r0.text1);
    ɵɵadvance(7);
    ɵɵtextInterpolate(ctx_r0.text2);
} }
class AmdocsPwaIosNotificationComponent {
    constructor(pwaService, deviceService) {
        this.pwaService = pwaService;
        this.deviceService = deviceService;
        this.text1 = 'Install this webapp on your iPhone:';
        this.text2 = 'and then add to home screen';
        this.pwaLocalStorageMaxDisplay = 20;
        this.disableOnClose = true;
        this.pwaLocalStorageCounterKey = 'pwa-ios-notification';
    }
    ngOnInit() {
        this.showProgressiveWebAppNotification = this.displayProgressiveWebAppNotification();
    }
    displayProgressiveWebAppNotification() {
        if (this.pwaService.isPwa()) {
            return false;
        }
        if ((this.deviceService.isIos() && this.deviceService.isSafari()) && !this.deviceService.isChromeIOS()) {
            const counter = parseInt(localStorage.getItem(this.pwaLocalStorageCounterKey), 10) || 0;
            if (counter < this.pwaLocalStorageMaxDisplay) {
                localStorage.setItem(this.pwaLocalStorageCounterKey, (counter + 1).toString());
                return true;
            }
        }
        return false;
    }
    closeProgressiveWebAppNotification() {
        this.showProgressiveWebAppNotification = false;
    }
    closeButtonClicked() {
        if (this.disableOnClose) {
            localStorage.setItem(this.pwaLocalStorageCounterKey, (this.pwaLocalStorageMaxDisplay + 1).toString());
        }
        this.closeProgressiveWebAppNotification();
    }
}
AmdocsPwaIosNotificationComponent.ɵfac = function AmdocsPwaIosNotificationComponent_Factory(t) { return new (t || AmdocsPwaIosNotificationComponent)(ɵɵdirectiveInject(AmdocsPwaService), ɵɵdirectiveInject(AmdocsDeviceService)); };
AmdocsPwaIosNotificationComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsPwaIosNotificationComponent, selectors: [["lib-amdocs-pwa-ios-notification"]], inputs: { text1: "text1", text2: "text2", pwaLocalStorageMaxDisplay: "pwaLocalStorageMaxDisplay", disableOnClose: "disableOnClose" }, decls: 1, vars: 1, consts: [["class", "ProgressiveWebApp-notification", "lib-amdocs-click-outside", "", 3, "clickOutside", 4, "ngIf"], ["lib-amdocs-click-outside", "", 1, "ProgressiveWebApp-notification", 3, "clickOutside"], [1, "box"], [1, "btn", "close-icon", 3, "click"], ["image-src", "", "src", "/assets/icons/close-purple.svg"], [1, "d-flex"], [1, "add-icon"], ["image-src", "", "src", "/assets/icons/add.svg"], [1, "content"], ["alt", "", "src", "/assets/icons/send-activity.svg", 1, "export-icon"]], template: function AmdocsPwaIosNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsPwaIosNotificationComponent_div_0_Template, 18, 2, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showProgressiveWebAppNotification);
    } }, directives: [NgIf, AmdocsClickOutsideDirective], styles: ["@media (max-width:1025px){.ProgressiveWebApp-notification[_ngcontent-%COMP%]{bottom:16px;position:fixed;width:100%}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]{background:#fff;border:1px solid #e8e9ed;border-radius:10px;box-shadow:0 2px 20px 0 rgba(127,130,215,.23);padding:15px;position:relative}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]:after, .ProgressiveWebApp-notification[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]:before{border:solid transparent;content:\" \";height:0;left:50%;pointer-events:none;position:absolute;top:100%;width:0}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]:after{border-color:#fff hsla(0,0%,96.1%,0) hsla(0,0%,96.1%,0);border-width:15px;margin-left:-15px}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]:before{border-color:#e8e9ed hsla(0,0%,94.1%,0) hsla(0,0%,94.1%,0);border-width:16px;margin-left:-16px}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#22212e;font-size:14px;line-height:21px}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .export-icon[_ngcontent-%COMP%]{height:18px;margin:0 3px}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]{line-height:1;padding:2px 8px;position:absolute;right:0}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:10px}.ProgressiveWebApp-notification[_ngcontent-%COMP%]   .add-icon[_ngcontent-%COMP%]{height:40px;margin-right:15px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPwaIosNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-pwa-ios-notification',
                templateUrl: './amdocs-pwa-ios-notification.component.html',
                styleUrls: ['./amdocs-pwa-ios-notification.component.scss']
            }]
    }], function () { return [{ type: AmdocsPwaService }, { type: AmdocsDeviceService }]; }, { text1: [{
            type: Input
        }], text2: [{
            type: Input
        }], pwaLocalStorageMaxDisplay: [{
            type: Input
        }], disableOnClose: [{
            type: Input
        }] }); })();

class AmdocsDatePipe {
    constructor(amdocsTimeService) {
        this.amdocsTimeService = amdocsTimeService;
    }
    transform(value, to = 'MMMM D, YYYY', from = this.amdocsTimeService.defaultServerDateTimeFormat, fromUTCtoLocal = false) {
        let date;
        if (fromUTCtoLocal) {
            date = this.amdocsTimeService.momentFromUTCToLocal(value).format(to);
        }
        else {
            date = this.amdocsTimeService.format(value, from, to);
        }
        return date;
    }
}
AmdocsDatePipe.ɵfac = function AmdocsDatePipe_Factory(t) { return new (t || AmdocsDatePipe)(ɵɵdirectiveInject(AmdocsTimeService)); };
AmdocsDatePipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsDate", type: AmdocsDatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsDatePipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsDate'
            }]
    }], function () { return [{ type: AmdocsTimeService }]; }, null); })();

class AmdocsStrongSpanPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, regex) {
        return this.sanitize(this.replace(value, regex));
    }
    replace(str, regex) {
        return str.replace(new RegExp(`(${regex})`, 'gi'), '<strong>$1</strong>');
    }
    sanitize(str) {
        return this.sanitizer.bypassSecurityTrustHtml(str);
    }
}
AmdocsStrongSpanPipe.ɵfac = function AmdocsStrongSpanPipe_Factory(t) { return new (t || AmdocsStrongSpanPipe)(ɵɵdirectiveInject(DomSanitizer)); };
AmdocsStrongSpanPipe.ɵpipe = ɵɵdefinePipe({ name: "amdocsStrongSpan", type: AmdocsStrongSpanPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsStrongSpanPipe, [{
        type: Pipe,
        args: [{
                name: 'amdocsStrongSpan'
            }]
    }], function () { return [{ type: DomSanitizer }]; }, null); })();

function AmdocsVersionUpdateComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 1);
    ɵɵelementStart(2, "div", 2);
    ɵɵtext(3);
    ɵɵpipe(4, "amdocsTranslate");
    ɵɵelementEnd();
    ɵɵelementStart(5, "button", 3);
    ɵɵlistener("click", function AmdocsVersionUpdateComponent_ng_container_0_Template_button_click_5_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.reload(); });
    ɵɵtext(6, "update");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ɵɵpipeBind1(4, 1, "newVersion.newVersionMessage"), " ");
} }
class AmdocsVersionUpdateComponent {
    constructor(eventBus) {
        this.eventBus = eventBus;
        this.showVersionUpdate = false;
        this.eventBus.on(AMDOCS_CONSTANTS.SHOW_NEW_VERSION_ALERT_EVENT, () => {
            this.showVersionUpdate = true;
        }, true);
    }
    reload() {
        window.location.reload();
    }
}
AmdocsVersionUpdateComponent.ɵfac = function AmdocsVersionUpdateComponent_Factory(t) { return new (t || AmdocsVersionUpdateComponent)(ɵɵdirectiveInject(AmdocsEventBusService)); };
AmdocsVersionUpdateComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsVersionUpdateComponent, selectors: [["lib-amdocs-version-alert"]], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "new-version", "d-flex", "justify-content-between", "align-items-center"], [1, "new-version-text", "text-medium-bold"], [1, "btn", "btn-medium", "secondary", "special-s2", 3, "click"]], template: function AmdocsVersionUpdateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsVersionUpdateComponent_ng_container_0_Template, 7, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showVersionUpdate);
    } }, directives: [NgIf], pipes: [AmdocsTranslatePipe], styles: [".new-version[_ngcontent-%COMP%]{background-color:#c63f42;border-radius:8px;box-shadow:0 2px 24px 0 rgba(34,33,46,.2),0 2px 8px 0 rgba(34,33,46,.12);left:20px;padding:20px;position:fixed;right:20px;top:20px;z-index:3000}.new-version[_ngcontent-%COMP%]   .new-version-text[_ngcontent-%COMP%]{color:#fff;width:50%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsVersionUpdateComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-version-alert',
                templateUrl: './amdocs-version-update.component.html',
                styleUrls: ['./amdocs-version-update.component.scss']
            }]
    }], function () { return [{ type: AmdocsEventBusService }]; }, null); })();

class AmdocsImageFallbackDirective {
    constructor(el) {
        this.el = el;
        this.fallback = false;
    }
    updateUrl() {
        if (!this.fallback) {
            this.fallback = true;
            this.el.nativeElement.src = this.defaultImageSrc;
        }
    }
}
AmdocsImageFallbackDirective.ɵfac = function AmdocsImageFallbackDirective_Factory(t) { return new (t || AmdocsImageFallbackDirective)(ɵɵdirectiveInject(ElementRef)); };
AmdocsImageFallbackDirective.ɵdir = ɵɵdefineDirective({ type: AmdocsImageFallbackDirective, selectors: [["", "lib-amdocs-image-fallback", ""]], hostBindings: function AmdocsImageFallbackDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("error", function AmdocsImageFallbackDirective_error_HostBindingHandler() { return ctx.updateUrl(); });
    } }, inputs: { defaultImageSrc: "defaultImageSrc" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsImageFallbackDirective, [{
        type: Directive,
        args: [{
                selector: '[lib-amdocs-image-fallback]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { defaultImageSrc: [{
            type: Input
        }], updateUrl: [{
            type: HostListener,
            args: ['error']
        }] }); })();

const _c0$8 = ["autocompleteOptionTemplate"];
function AmdocsAutocompleteComponent_div_1_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 7);
} }
function AmdocsAutocompleteComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 5);
    ɵɵelementStart(1, "div");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, AmdocsAutocompleteComponent_div_1_img_3_Template, 1, 0, "img", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.label);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
const _c1$4 = function (a0) { return { "d-flex align-items-center justify-content-start": a0 }; };
function AmdocsAutocompleteComponent_ng_template_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelementContainerStart(1);
    ɵɵelement(2, "input", 13);
    ɵɵelement(3, "span", 14);
    ɵɵelementContainerEnd();
    ɵɵtext(4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext();
    const item$_r5 = ctx_r11.item$;
    const index_r7 = ctx_r11.index;
    const item_r4 = ctx_r11.item;
    const ctx_r8 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(4, _c1$4, ctx_r8.isMultiple));
    ɵɵadvance(2);
    ɵɵproperty("ngModel", item$_r5.selected)("id", "drop-down-multiple-item-" + index_r7);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", item_r4.name, " ");
} }
function AmdocsAutocompleteComponent_ng_template_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 15);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext();
    const search_r6 = ctx_r12.searchTerm;
    const item_r4 = ctx_r12.item;
    const ctx_r9 = ɵɵnextContext();
    ɵɵproperty("ngOptionHighlight", search_r6)("ngClass", ɵɵpureFunction1(3, _c1$4, ctx_r9.isMultiple));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r4.name, " ");
} }
function AmdocsAutocompleteComponent_ng_template_3_ng_container_3_ng_template_1_Template(rf, ctx) { }
const _c2$2 = function (a0) { return [a0]; };
function AmdocsAutocompleteComponent_ng_template_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsAutocompleteComponent_ng_template_3_ng_container_3_ng_template_1_Template, 0, 0, "ng-template", 16);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r4 = ɵɵnextContext().item;
    const ctx_r10 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpureFunction1(2, _c2$2, item_r4))("ngForTemplate", ctx_r10.autocompleteOptionTemplate);
} }
const _c3$2 = function (a0, a1) { return { "is-group": a0, "highlight-result": a1 }; };
function AmdocsAutocompleteComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵtemplate(1, AmdocsAutocompleteComponent_ng_template_3_div_1_Template, 5, 6, "div", 9);
    ɵɵtemplate(2, AmdocsAutocompleteComponent_ng_template_3_div_2_Template, 2, 5, "div", 10);
    ɵɵtemplate(3, AmdocsAutocompleteComponent_ng_template_3_ng_container_3_Template, 2, 4, "ng-container", 11);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.item;
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction2(4, _c3$2, item_r4.isGroup, ctx_r1.highlightResults));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r1.autocompleteOptionTemplate && ctx_r1.isMultiple);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r1.autocompleteOptionTemplate && !ctx_r1.isMultiple);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.autocompleteOptionTemplate);
} }
function AmdocsAutocompleteComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 17);
    ɵɵelement(1, "img", 18);
    ɵɵelementStart(2, "span", 19);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ctx_r2.errorsMessage, " ");
} }
const _c4$1 = function (a0, a1) { return { "has-hierarchy": a0, "rounded": a1 }; };
class AmdocsAutocompleteComponent {
    constructor() {
        this.placeholder = 'select';
        this.virtualScroll = true;
        this.readOnly = false;
        this.highlightResults = true;
        this.clearable = true;
        this.hideLabel = false;
        this.hasHierarchy = true;
        this.itemChangedCallback = new EventEmitter();
        this.selectedItemCleared = new EventEmitter();
        this.isRequired = false;
        this.disabled = false;
        this.isRounded = false;
        this.isMultiple = false;
        this.selectIfOneItem = true;
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.items) {
            if (((_a = this.items) === null || _a === void 0 ? void 0 : _a.length) === 1 && this.selectIfOneItem) {
                this.selectedItemCode = this.items[0].code;
                this.itemChangedEvent();
            }
            else {
                if (this.selectedItemCode) {
                    const tmpItems = changes.items;
                    if (tmpItems && tmpItems.find) {
                        if (!tmpItems.find(i => i.code === this.selectedItemCode)) {
                            this.selectedItemCode = null;
                            this.itemChangedEvent();
                        }
                    }
                }
            }
        }
    }
    ngOnInit() {
    }
    itemChangedEvent() {
        var _a;
        let selectedItem;
        if (this.isMultiple) {
            selectedItem = ((_a = this.selectedItemCode) === null || _a === void 0 ? void 0 : _a.every(elem => this.items.find(i => i.code === elem))) ? this.selectedItemCode : [];
        }
        else {
            selectedItem = this.items.find(i => i.code === this.selectedItemCode);
        }
        this.itemChangedCallback.emit(selectedItem);
    }
}
AmdocsAutocompleteComponent.ɵfac = function AmdocsAutocompleteComponent_Factory(t) { return new (t || AmdocsAutocompleteComponent)(); };
AmdocsAutocompleteComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsAutocompleteComponent, selectors: [["lib-amdocs-autocomplete"]], contentQueries: function AmdocsAutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, _c0$8, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.autocompleteOptionTemplate = _t.first);
    } }, inputs: { label: "label", items: "items", selectedItemCode: "selectedItemCode", placeholder: "placeholder", virtualScroll: "virtualScroll", readOnly: "readOnly", highlightResults: "highlightResults", clearable: "clearable", hideLabel: "hideLabel", hasHierarchy: "hasHierarchy", errorsMessage: "errorsMessage", isRequired: "isRequired", disabled: "disabled", isRounded: "isRounded", isMultiple: "isMultiple", selectIfOneItem: "selectIfOneItem" }, outputs: { itemChangedCallback: "itemChangedCallback", selectedItemCleared: "selectedItemCleared" }, features: [ɵɵNgOnChangesFeature], decls: 5, vars: 17, consts: [[1, "autocomplete-wrapper", 3, "ngClass"], ["class", "custom-input-label text-color-secondary autocomplete-label d-flex", 4, "ngIf"], ["bindLabel", "name", "bindValue", "code", 1, "select-wrapper", 3, "items", "multiple", "readonly", "ngModel", "placeholder", "clearable", "closeOnSelect", "disabled", "virtualScroll", "ngModelChange", "clear", "change"], ["ng-option-tmp", ""], ["class", "custom-input-field-error", 4, "ngIf"], [1, "custom-input-label", "text-color-secondary", "autocomplete-label", "d-flex"], ["class", "autocomplete-img", "src", "assets/icons/asterisk.svg", 4, "ngIf"], ["src", "assets/icons/asterisk.svg", 1, "autocomplete-img"], [1, "item", 3, "ngClass"], ["class", "text-small-normal", 3, "ngClass", 4, "ngIf"], ["class", "text-small-normal", 3, "ngOptionHighlight", "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "text-small-normal", 3, "ngClass"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModel", "id"], [1, "custom-control-indicator", "align-items-center", "d-flex", "justify-content-center"], [1, "text-small-normal", 3, "ngOptionHighlight", "ngClass"], ["ngFor", "", 3, "ngForOf", "ngForTemplate"], [1, "custom-input-field-error"], ["src", "/assets/icons/error.svg"], [1, "text-small-normal"]], template: function AmdocsAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AmdocsAutocompleteComponent_div_1_Template, 4, 2, "div", 1);
        ɵɵelementStart(2, "ng-select", 2);
        ɵɵlistener("ngModelChange", function AmdocsAutocompleteComponent_Template_ng_select_ngModelChange_2_listener($event) { return ctx.selectedItemCode = $event; })("clear", function AmdocsAutocompleteComponent_Template_ng_select_clear_2_listener() { return ctx.selectedItemCleared.emit(); })("change", function AmdocsAutocompleteComponent_Template_ng_select_change_2_listener() { return ctx.itemChangedEvent(); });
        ɵɵtemplate(3, AmdocsAutocompleteComponent_ng_template_3_Template, 4, 7, "ng-template", 3);
        ɵɵelementEnd();
        ɵɵtemplate(4, AmdocsAutocompleteComponent_div_4_Template, 4, 1, "div", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ɵɵpureFunction2(14, _c4$1, ctx.hasHierarchy, ctx.isRounded));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.hideLabel);
        ɵɵadvance(1);
        ɵɵclassProp("invalid", ctx.errorsMessage);
        ɵɵproperty("items", ctx.items)("multiple", ctx.isMultiple)("readonly", ctx.readOnly)("ngModel", ctx.selectedItemCode)("placeholder", ctx.placeholder)("clearable", ctx.clearable)("closeOnSelect", !ctx.isMultiple)("disabled", ctx.disabled)("virtualScroll", ctx.virtualScroll);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.errorsMessage);
    } }, directives: [NgClass, NgIf, NgSelectComponent, NgControlStatus, NgModel, ɵf, CheckboxControlValueAccessor, NgOptionHighlightDirective, NgForOf], styles: [".autocomplete-wrapper[_ngcontent-%COMP%]{width:100%}.autocomplete-wrapper.rounded[_ngcontent-%COMP%]     .ng-select .ng-select-container{border:1px solid #22212e;border-radius:20px;box-shadow:none;height:32px;padding:6px 16px}.autocomplete-wrapper.rounded[_ngcontent-%COMP%]     .ng-select .ng-select-container.ng-has-value, .autocomplete-wrapper.rounded[_ngcontent-%COMP%]     .ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#22212e;font-weight:500}.autocomplete-wrapper[_ngcontent-%COMP%]   .autocomplete-label[_ngcontent-%COMP%]{margin-bottom:8px}.autocomplete-wrapper[_ngcontent-%COMP%]   .autocomplete-label[_ngcontent-%COMP%]   .autocomplete-img[_ngcontent-%COMP%]{margin-left:14px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel{background-color:#fff;border-radius:6px;box-shadow:0 2px 24px 0 rgba(34,33,46,.2),0 2px 8px 0 rgba(34,33,46,.12)}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option{padding:0;text-align:start;white-space:normal}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option.ng-option-disabled{cursor:auto}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option.ng-option-disabled .item{color:#a3a3ae}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option .item{color:#22212e;min-height:36px;padding:8px 16px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option.ng-option-marked .item, .autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option.ng-option-selected .item{background-color:#f05c62;color:#fff}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option.ng-option-marked .item .text-small-normal, .autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option.ng-option-selected .item .text-small-normal{font-weight:700}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel.ng-select-multiple .ng-option.ng-option-marked, .autocomplete-wrapper[_ngcontent-%COMP%]     .ng-dropdown-panel.ng-select-multiple .ng-option.ng-option-selected{background-color:transparent}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.invalid .ng-select-container{border-color:#e60001}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-clear-wrapper:before{background-image:url(/assets/icons/close-purple.svg);background-size:cover;content:\"\";height:10px;position:absolute;width:10px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-arrow-wrapper:before{background-image:url(/assets/icons/arrow-down.svg);background-repeat:no-repeat;content:\"\";height:8px;position:absolute;width:13px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-arrow-wrapper .ng-arrow, .autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-clear-wrapper .ng-clear{display:none}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-arrow-wrapper, .autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-clear-wrapper{align-items:center;display:flex;height:100%}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-focused .ng-select-container{border:2px solid #ee9497;box-shadow:inset 0 0 1px 0 rgba(0,0,0,.1)}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-select-container{align-items:center;border:2px solid #f1f1f4;border-radius:8px;box-shadow:inset 0 0 1px 0 rgba(0,0,0,.1);display:flex;height:44px;padding:12px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-select-container .ng-value-container{padding:0}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-select-container .ng-value-container .ng-input{top:auto}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#22212e}.autocomplete-wrapper.has-hierarchy[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option:first-child .item.is-group{border-top:none}.autocomplete-wrapper.has-hierarchy[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option .item{padding:8px 45px}.autocomplete-wrapper.has-hierarchy[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option .item.is-group{border-top:1px solid #f1f1f4;padding:8px 16px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-multiple .ng-select-container{height:auto;min-height:44px;padding:6px}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{position:relative}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{align-items:center;background-color:rgba(127,130,215,.16);display:flex;height:28px;margin-bottom:0}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:none;font-size:20px;position:relative;top:0}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-multiple .ng-select-container.ng-has-value{padding:6px 6px 0}.autocomplete-wrapper[_ngcontent-%COMP%]     .ng-select.ng-select-multiple .ng-select-container.ng-has-value .ng-value-container .ng-value{margin-bottom:6px}.autocomplete-wrapper[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]{background-color:#f1f1f4;border:2px solid #22212e;border-radius:8px;content:\"\";display:inline-block;height:24px;margin:0 12px 0 0;min-width:24px;opacity:.5;transition:border .5s;width:24px}.autocomplete-wrapper[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]:hover{cursor:pointer}.autocomplete-wrapper[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]{display:none}.autocomplete-wrapper[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]:checked + .custom-control-indicator[_ngcontent-%COMP%]{border-width:12px;opacity:1;transition:.5s}.autocomplete-wrapper[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]:checked + .custom-control-indicator[_ngcontent-%COMP%]:after{animation-delay:.3s;animation-duration:.2s;animation-fill-mode:forwards;animation-name:fadeIn;content:url(/assets/icons/checkmark-icon.svg);opacity:1;position:relative;top:1px;transform:scale(0)}.autocomplete-wrapper[_ngcontent-%COMP%]   input.custom-control-input[_ngcontent-%COMP%]:disabled + .custom-control-indicator[_ngcontent-%COMP%]{border-color:#c9c9d3}.autocomplete-wrapper[_ngcontent-%COMP%]   .custom-control-description.disabled[_ngcontent-%COMP%]{color:#c9c9d3}@keyframes fadeIn{0%{transform:scale(0)}50%{transform:scale(1.3)}to{transform:scale(1)}}@keyframes fadeOut{0%{transform:scale(1)}50%{transform:scale(1.3)}to{transform:scale(0)}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-autocomplete',
                templateUrl: './amdocs-autocomplete.component.html',
                styleUrls: ['./amdocs-autocomplete.component.scss']
            }]
    }], null, { label: [{
            type: Input
        }], items: [{
            type: Input
        }], selectedItemCode: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], virtualScroll: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], highlightResults: [{
            type: Input
        }], clearable: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], hasHierarchy: [{
            type: Input
        }], itemChangedCallback: [{
            type: Output
        }], selectedItemCleared: [{
            type: Output
        }], errorsMessage: [{
            type: Input
        }], isRequired: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isRounded: [{
            type: Input
        }], isMultiple: [{
            type: Input
        }], selectIfOneItem: [{
            type: Input
        }], autocompleteOptionTemplate: [{
            type: ContentChild,
            args: ['autocompleteOptionTemplate']
        }] }); })();
class IAutocompleteItem {
}

const _c0$9 = ["tableHeader"];
function AmdocsTableHeaderComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 1);
    ɵɵlistener("click", function AmdocsTableHeaderComponent_ng_template_0_Template_div_click_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.headerClick($event); });
    ɵɵprojection(1);
    ɵɵelementEnd();
} }
const _c1$5 = ["*"];
class AmdocsTableHeaderComponent {
    constructor() {
        this.data = {};
        this.headerClickCallback = new EventEmitter();
    }
    ngAfterContentInit() {
    }
    headerClick($event) {
        if (this.headerClickCallback.observers.length) {
            $event.stopPropagation();
            this.headerClickCallback.emit(this.data);
        }
    }
}
AmdocsTableHeaderComponent.ɵfac = function AmdocsTableHeaderComponent_Factory(t) { return new (t || AmdocsTableHeaderComponent)(); };
AmdocsTableHeaderComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTableHeaderComponent, selectors: [["lib-amdocs-table-header"]], viewQuery: function AmdocsTableHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$9, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.tableHeader = _t.first);
    } }, inputs: { data: "data" }, outputs: { headerClickCallback: "headerClickCallback" }, ngContentSelectors: _c1$5, decls: 2, vars: 0, consts: [["tableHeader", ""], ["role", "columnheader", 1, "rc-table-header", 3, "click"]], template: function AmdocsTableHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, AmdocsTableHeaderComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, ɵɵtemplateRefExtractor);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTableHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-table-header',
                templateUrl: './amdocs-table-header.component.html',
                styleUrls: ['./amdocs-table-header.component.scss']
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }], headerClickCallback: [{
            type: Output
        }], tableHeader: [{
            type: ViewChild,
            args: ['tableHeader']
        }] }); })();

const _c0$a = ["tableCell"];
const _c1$6 = function (a0) { return { width: a0 }; };
function AmdocsTableCellComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 1);
    ɵɵlistener("click", function AmdocsTableCellComponent_ng_template_0_Template_div_click_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.colClicked($event); });
    ɵɵprojection(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("ngStyle", ɵɵpureFunction1(1, _c1$6, ctx_r1.col.width));
} }
const _c2$3 = ["*"];
class AmdocsTableCellComponent {
    constructor() {
        this.col = {};
    }
    colClicked(event) {
        event.rcTableCol = this.col;
    }
}
AmdocsTableCellComponent.ɵfac = function AmdocsTableCellComponent_Factory(t) { return new (t || AmdocsTableCellComponent)(); };
AmdocsTableCellComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTableCellComponent, selectors: [["lib-amdocs-table-cell"]], viewQuery: function AmdocsTableCellComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$a, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.tableCell = _t.first);
    } }, inputs: { col: "col" }, ngContentSelectors: _c2$3, decls: 2, vars: 0, consts: [["tableCell", ""], ["role", "gridcell", 1, "rc-table-cell", 3, "ngStyle", "click"]], template: function AmdocsTableCellComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, AmdocsTableCellComponent_ng_template_0_Template, 2, 3, "ng-template", null, 0, ɵɵtemplateRefExtractor);
    } }, directives: [NgStyle], styles: [".rc-table-cell[_ngcontent-%COMP%]{color:#22212e;font-family:Montserrat;font-size:12px;letter-spacing:0;line-height:15px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTableCellComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-table-cell',
                templateUrl: './amdocs-table-cell.component.html',
                styleUrls: ['./amdocs-table-cell.component.scss']
            }]
    }], null, { col: [{
            type: Input
        }], tableCell: [{
            type: ViewChild,
            args: ['tableCell']
        }] }); })();

const _c0$b = ["tableRow"];
const _c1$7 = function (a0) { return { col: a0 }; };
function AmdocsTableRowComponent_ng_template_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementContainer(1, 4);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    const cell_r3 = ctx_r6.$implicit;
    const i_r4 = ctx_r6.index;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", cell_r3.tableCell)("ngTemplateOutletContext", ɵɵpureFunction1(2, _c1$7, ctx_r5.cols[i_r4]));
} }
function AmdocsTableRowComponent_ng_template_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsTableRowComponent_ng_template_0_ng_container_1_ng_container_1_Template, 2, 4, "ng-container", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(ctx_r2.colsConfig[i_r4] == null ? null : ctx_r2.colsConfig[i_r4].hidden));
} }
function AmdocsTableRowComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵtemplate(1, AmdocsTableRowComponent_ng_template_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.cells.toArray());
} }
class AmdocsTableRowComponent {
    constructor() {
        this.cols = [];
        this.rowData = [];
        this.colsConfig = [];
        this.rowDisabled = false;
        this.drawerDisabled = false;
    }
    ngAfterContentInit() {
        // console.log('this.colsConfig', this.colsConfig); //
    }
}
AmdocsTableRowComponent.ɵfac = function AmdocsTableRowComponent_Factory(t) { return new (t || AmdocsTableRowComponent)(); };
AmdocsTableRowComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTableRowComponent, selectors: [["lib-amdocs-table-row"]], contentQueries: function AmdocsTableRowComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, AmdocsTableCellComponent, false);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.cells = _t);
    } }, viewQuery: function AmdocsTableRowComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$b, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.tableRow = _t.first);
    } }, inputs: { cols: "cols", rowData: "rowData", colsConfig: "colsConfig", rowDisabled: "rowDisabled", drawerDisabled: "drawerDisabled" }, decls: 2, vars: 0, consts: [["tableRow", ""], [1, "rc-table-row"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function AmdocsTableRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsTableRowComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, ɵɵtemplateRefExtractor);
    } }, directives: [NgForOf, NgIf, NgTemplateOutlet], styles: [".rc-table-row[_ngcontent-%COMP%]{align-items:center;display:flex;min-height:45px;padding-left:17px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTableRowComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-table-row',
                templateUrl: './amdocs-table-row.component.html',
                styleUrls: ['./amdocs-table-row.component.scss']
            }]
    }], null, { cols: [{
            type: Input
        }], rowData: [{
            type: Input
        }], colsConfig: [{
            type: Input
        }], rowDisabled: [{
            type: Input
        }], drawerDisabled: [{
            type: Input
        }], cells: [{
            type: ContentChildren,
            args: [AmdocsTableCellComponent]
        }], tableRow: [{
            type: ViewChild,
            args: ['tableRow', { read: TemplateRef, static: true }]
        }] }); })();

const _c0$c = ["tableDrawer"];
function AmdocsTableDrawerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵprojection(1);
    ɵɵelementEnd();
} }
const _c1$8 = ["*"];
class AmdocsTableDrawerComponent {
    constructor() {
        this.rowData = {};
    }
    ngAfterContentInit() {
    }
}
AmdocsTableDrawerComponent.ɵfac = function AmdocsTableDrawerComponent_Factory(t) { return new (t || AmdocsTableDrawerComponent)(); };
AmdocsTableDrawerComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTableDrawerComponent, selectors: [["lib-amdocs-table-drawer"]], viewQuery: function AmdocsTableDrawerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$c, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.tableDrawer = _t.first);
    } }, inputs: { rowData: "rowData" }, ngContentSelectors: _c1$8, decls: 2, vars: 0, consts: [["tableDrawer", ""], [1, "rc-table-drawer"]], template: function AmdocsTableDrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, AmdocsTableDrawerComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, ɵɵtemplateRefExtractor);
    } }, styles: [".rc-table-drawer[_ngcontent-%COMP%]{background-color:#f1f1f4;border-radius:4px;min-height:77px;padding:20px 24.5px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTableDrawerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-table-drawer',
                templateUrl: './amdocs-table-drawer.component.html',
                styleUrls: ['./amdocs-table-drawer.component.scss']
            }]
    }], null, { rowData: [{
            type: Input
        }], tableDrawer: [{
            type: ViewChild,
            args: ['tableDrawer']
        }] }); })();

const _c0$d = ["amdocsTableHeaderWrapper"];
const _c1$9 = ["amdocsTableBodyWrapper"];
function AmdocsTableComponent_div_0_ng_container_3_ng_container_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 12);
} }
const _c2$4 = function (a0) { return { "sortable": a0 }; };
const _c3$3 = function (a0) { return { width: a0 }; };
const _c4$2 = function (a0, a1) { return { data: a0, headerClickCallback: a1 }; };
function AmdocsTableComponent_div_0_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 8);
    ɵɵlistener("click", function AmdocsTableComponent_div_0_ng_container_3_ng_container_1_Template_div_click_1_listener() { ɵɵrestoreView(_r11); const header_r5 = ɵɵnextContext().$implicit; const ctx_r9 = ɵɵnextContext(2); return ctx_r9.headerClick(header_r5); });
    ɵɵelementStart(2, "div", 9);
    ɵɵelementContainer(3, 10);
    ɵɵelementEnd();
    ɵɵtemplate(4, AmdocsTableComponent_div_0_ng_container_3_ng_container_1_span_4_Template, 1, 0, "span", 11);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext();
    const header_r5 = ctx_r12.$implicit;
    const i_r6 = ctx_r12.index;
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("rc-table-header-wrapper ", ctx_r7.getSortClasses(header_r5), "");
    ɵɵproperty("ngClass", ɵɵpureFunction1(8, _c2$4, ctx_r7.gridConfig.cols[i_r6].sortable))("ngStyle", ɵɵpureFunction1(10, _c3$3, ctx_r7.gridConfig.cols[i_r6].width));
    ɵɵadvance(2);
    ɵɵproperty("ngTemplateOutlet", header_r5.tableHeader)("ngTemplateOutletContext", ɵɵpureFunction2(12, _c4$2, header_r5.data, header_r5.headerClickCallback));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r7.isSorted(header_r5));
} }
function AmdocsTableComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsTableComponent_div_0_ng_container_3_ng_container_1_Template, 5, 15, "ng-container", 7);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r6 = ctx.index;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.gridConfig.cols[i_r6].hidden);
} }
const _c5$1 = function (a0) { return { rowData: a0 }; };
function AmdocsTableComponent_div_0_ng_container_6_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 15);
    ɵɵelementContainer(1, 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(2);
    const i_r14 = ctx_r17.index;
    const row_r13 = ctx_r17.$implicit;
    const ctx_r16 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r16.drawers.toArray()[i_r14].tableDrawer)("ngTemplateOutletContext", ɵɵpureFunction1(2, _c5$1, row_r13.rowData));
} }
const _c6 = function (a0, a1, a2) { return { "open": a0, "disabled": a1, "with-drawer": a2 }; };
const _c7 = function (a0, a1) { return { colsConfig: a0, rowData: a1 }; };
function AmdocsTableComponent_div_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 13);
    ɵɵlistener("keydown", function AmdocsTableComponent_div_0_ng_container_6_ng_container_1_Template_div_keydown_1_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(); const row_r13 = ctx_r20.$implicit; const i_r14 = ctx_r20.index; const ctx_r18 = ɵɵnextContext(2); return ctx_r18.onKeyDown($event, row_r13, i_r14); })("click", function AmdocsTableComponent_div_0_ng_container_6_ng_container_1_Template_div_click_1_listener($event) { ɵɵrestoreView(_r19); const ctx_r22 = ɵɵnextContext(); const row_r13 = ctx_r22.$implicit; const i_r14 = ctx_r22.index; const ctx_r21 = ɵɵnextContext(2); return ctx_r21.rowClick(row_r13, i_r14, $event); });
    ɵɵelementContainer(2, 10);
    ɵɵelementEnd();
    ɵɵtemplate(3, AmdocsTableComponent_div_0_ng_container_6_ng_container_1_div_3_Template, 2, 4, "div", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = ɵɵnextContext();
    const i_r14 = ctx_r23.index;
    const row_r13 = ctx_r23.$implicit;
    const ctx_r15 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("rc-table-row-wrapper ", ctx_r15.gridRows[i_r14].rowCustomClass, "");
    ɵɵproperty("ngClass", ɵɵpureFunction3(8, _c6, ctx_r15.gridRows[i_r14].drawerOpened, row_r13.rowDisabled, ctx_r15.gridConfig.haveDrawer && !row_r13.drawerDisabled));
    ɵɵattribute("aria-expanded", ctx_r15.gridRows[i_r14].drawerOpened);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", row_r13.tableRow)("ngTemplateOutletContext", ɵɵpureFunction2(12, _c7, ctx_r15.gridConfig, row_r13.rowData));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r15.gridConfig.haveDrawer && ctx_r15.gridRows[i_r14].drawerOpened);
} }
function AmdocsTableComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AmdocsTableComponent_div_0_ng_container_6_ng_container_1_Template, 4, 15, "ng-container", 7);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r14 = ctx.index;
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.showRowByPage(i_r14));
} }
const _c8 = function (a0) { return { "with-drawer": a0 }; };
function AmdocsTableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2, 3);
    ɵɵtemplate(3, AmdocsTableComponent_div_0_ng_container_3_Template, 2, 1, "ng-container", 4);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 5, 6);
    ɵɵtemplate(6, AmdocsTableComponent_div_0_ng_container_6_Template, 2, 1, "ng-container", 4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c8, ctx_r0.gridConfig.haveDrawer));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.headers.toArray());
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ctx_r0.rows.toArray());
} }
class AmdocsTableComponent {
    constructor() {
        this.gridRows = [];
        this.pageNumber = 0;
        this.footerRows = [];
        this.serverSideSorting = false;
        this.rowClickCallback = new EventEmitter();
        this.headerClickCallback = new EventEmitter();
        this.asc = true;
        this.sortedHeader = {};
        this.renderTable = false;
    }
    ngOnInit() {
        this.gridConfig.cols.map((c) => {
            c.initialWidth = parseInt(c.width.replace('%', ''), 10);
        });
    }
    ngAfterViewInit() {
        this.calculateHeaderPadding();
        this.recalculateCols();
        this.renderTable = true;
    }
    ngOnChanges(changes) {
        this.calculateHeaderPadding();
    }
    calculateHeaderPadding() {
        if (!this.amdocsTableBodyWrapper || !this.amdocsTableHeaderWrapper) {
            return;
        }
        const style = window.getComputedStyle(this.amdocsTableBodyWrapper.nativeElement);
        const bodyClientWidth = this.amdocsTableBodyWrapper.nativeElement.clientWidth;
        const bodyOffsetWidth = this.amdocsTableBodyWrapper.nativeElement.offsetWidth;
        const padding = bodyOffsetWidth - bodyClientWidth;
        if (padding) {
            if (style.direction === 'ltr') {
                this.amdocsTableHeaderWrapper.nativeElement.style.paddingRight = padding + 'px';
            }
            else {
                this.amdocsTableHeaderWrapper.nativeElement.style.paddingLeft = padding + 'px';
            }
        }
    }
    headerClick(header) {
        if (header.data.sortable) {
            if (!this.serverSideSorting) {
                this.gridRows = this.sortArrayByKey(this.gridRows, header.data.field, this.asc);
            }
            this.asc = !this.asc;
            this.sortedHeader = header.data;
        }
        if (this.headerClickCallback.observers.length) {
            const sortObj = {
                col: header.data,
                direction: this.asc ? 'asc' : 'desc'
            };
            this.headerClickCallback.emit(sortObj);
        }
    }
    rowClick(row, i, event) {
        if (this.rowClickCallback.observers.length) {
            this.rowClickCallback.emit(row.rowData);
        }
        if (event.rcTableCol && event.rcTableCol.preventDrawerToggle) {
            return;
        }
        if (this.gridConfig.haveDrawer && !row.drawerDisabled) {
            this.toggleDrawer(i);
        }
    }
    sortArrayByKey(arr, key, asc = true) {
        if (asc) {
            arr.sort((a, b) => {
                const aKey = typeof a[key] === 'string' ? a[key].toLowerCase() : a[key];
                const bKey = typeof b[key] === 'string' ? b[key].toLowerCase() : b[key];
                return (aKey > bKey ? -1 : 1);
            });
        }
        else {
            arr.sort((a, b) => {
                const aKey = typeof a[key] === 'string' ? a[key].toLowerCase() : a[key];
                const bKey = typeof b[key] === 'string' ? b[key].toLowerCase() : b[key];
                return (aKey < bKey ? -1 : 1);
            });
        }
        return arr;
    }
    getSortClasses(header) {
        const classes = [];
        if (this.isSorted(header)) {
            classes.push('sorted');
            classes.push(this.asc ? 'asc' : 'desc');
        }
        return classes.join(' ');
    }
    isSorted(header) {
        return header.data.field === this.sortedHeader.field;
    }
    toggleDrawer(i) {
        this.gridRows[i].drawerOpened = !this.gridRows[i].drawerOpened;
    }
    onKeyDown($event, row, i) {
        if ($event.which === 13) {
            if (this.gridConfig.haveDrawer) {
                this.rowClick(row, i, $event);
            }
        }
    }
    showRowByPage(i) {
        if (this.gridConfig.hasClientPaging) {
            return i >= this.pageNumber * this.gridConfig.pageSize && i < (this.pageNumber + 1) * this.gridConfig.pageSize;
        }
        return true;
    }
    recalculateCols() {
        const tmpConfig = JSON.parse(JSON.stringify(this.gridConfig));
        const total = tmpConfig.cols.filter(c => !c.hidden).reduce((prev, curr) => {
            return prev + curr.initialWidth;
        }, 0);
        let totalAfter = 0;
        tmpConfig.cols.filter(c => !c.hidden).map((col) => {
            col.width = Math.floor(((100 / total) * (col.initialWidth)) * 100) / 100;
            totalAfter += col.width;
        });
        tmpConfig.cols.filter(c => !c.hidden)[0].width += (100 - totalAfter);
        tmpConfig.cols.filter(c => !c.hidden).map(c => c.width = c.width + '%');
        tmpConfig.cols.forEach((tmp, i) => {
            this.gridConfig.cols[i].width = tmp.width;
        });
    }
}
AmdocsTableComponent.ɵfac = function AmdocsTableComponent_Factory(t) { return new (t || AmdocsTableComponent)(); };
AmdocsTableComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTableComponent, selectors: [["lib-amdocs-table"]], contentQueries: function AmdocsTableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, AmdocsTableHeaderComponent, false);
        ɵɵcontentQuery(dirIndex, AmdocsTableRowComponent, false);
        ɵɵcontentQuery(dirIndex, AmdocsTableDrawerComponent, false);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.headers = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.rows = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.drawers = _t);
    } }, viewQuery: function AmdocsTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$d, true);
        ɵɵviewQuery(_c1$9, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.amdocsTableHeaderWrapper = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.amdocsTableBodyWrapper = _t.first);
    } }, inputs: { gridConfig: "gridConfig", gridRows: "gridRows", pageNumber: "pageNumber", footerRows: "footerRows", serverSideSorting: "serverSideSorting" }, outputs: { rowClickCallback: "rowClickCallback", headerClickCallback: "headerClickCallback" }, features: [ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "rc-table-wrapper", "role", "grid", 4, "ngIf"], ["role", "grid", 1, "rc-table-wrapper"], ["role", "row", 1, "amdocs-table-headers-wrapper", 3, "ngClass"], ["amdocsTableHeaderWrapper", ""], [4, "ngFor", "ngForOf"], [1, "rc-table-body-wrapper"], ["amdocsTableBodyWrapper", ""], [4, "ngIf"], [3, "ngClass", "ngStyle", "click"], [1, "rc-table-header-cell-content-wrapper"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "sort-indicator ", 4, "ngIf"], [1, "sort-indicator"], ["role", "row", 3, "ngClass", "keydown", "click"], ["class", "rc-table-drawer-wrapper", 4, "ngIf"], [1, "rc-table-drawer-wrapper"]], template: function AmdocsTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsTableComponent_div_0_Template, 7, 5, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.renderTable);
    } }, directives: [NgIf, NgClass, NgForOf, NgStyle, NgTemplateOutlet], styles: [".rc-table-wrapper[_ngcontent-%COMP%]{position:relative}.rc-table-wrapper[_ngcontent-%COMP%]   .table-header-inview[_ngcontent-%COMP%]{height:0;left:0;position:absolute;top:0}.rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper[_ngcontent-%COMP%]{background-color:#f1f1f4;border-radius:2px;height:34px;padding-left:17px}.rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper.with-drawer[_ngcontent-%COMP%]{padding-left:47px}.rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper[_ngcontent-%COMP%]   .rc-table-header-wrapper[_ngcontent-%COMP%]{color:#343647;display:inline-block;font-family:Montserrat;font-size:12px;font-weight:600;letter-spacing:0;line-height:15px;padding-bottom:9px;padding-top:10px;text-align:left}.rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper[_ngcontent-%COMP%]   .rc-table-header-wrapper[_ngcontent-%COMP%]   .rc-table-header-cell-content-wrapper[_ngcontent-%COMP%]{display:inline-block}.rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper[_ngcontent-%COMP%]   .rc-table-header-wrapper.sortable[_ngcontent-%COMP%]{cursor:pointer}.rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper[_ngcontent-%COMP%]   .rc-table-header-wrapper.sorted.asc[_ngcontent-%COMP%]   .sort-indicator[_ngcontent-%COMP%]:before, .rc-table-wrapper[_ngcontent-%COMP%]   .amdocs-table-headers-wrapper[_ngcontent-%COMP%]   .rc-table-header-wrapper.sorted.desc[_ngcontent-%COMP%]   .sort-indicator[_ngcontent-%COMP%]:before{content:\"\"}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-row-wrapper[_ngcontent-%COMP%]{border-bottom:1px solid #e8e9ed}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-row-wrapper.with-drawer[_ngcontent-%COMP%]{position:relative}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-row-wrapper.with-drawer[_ngcontent-%COMP%]:before{background-image:url(/assets/icons/table-drawer-closed.svg);content:\"\";height:24px;left:12px;position:absolute;top:12px;width:24px}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-row-wrapper.with-drawer[_ngcontent-%COMP%]     .rc-table-row{margin-left:30px}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-row-wrapper.open[_ngcontent-%COMP%]{border-bottom:none}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-row-wrapper.open[_ngcontent-%COMP%]:before{background-image:url(/assets/icons/table-drawer-opened.svg);content:\"\"}.rc-table-wrapper[_ngcontent-%COMP%]   .rc-table-drawer-wrapper[_ngcontent-%COMP%]{border-bottom:1px solid #e8e9ed;padding:15px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTableComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-table',
                templateUrl: './amdocs-table.component.html',
                styleUrls: ['./amdocs-table.component.scss']
            }]
    }], null, { headers: [{
            type: ContentChildren,
            args: [AmdocsTableHeaderComponent]
        }], rows: [{
            type: ContentChildren,
            args: [AmdocsTableRowComponent]
        }], drawers: [{
            type: ContentChildren,
            args: [AmdocsTableDrawerComponent]
        }], gridConfig: [{
            type: Input
        }], gridRows: [{
            type: Input
        }], pageNumber: [{
            type: Input
        }], footerRows: [{
            type: Input
        }], serverSideSorting: [{
            type: Input
        }], rowClickCallback: [{
            type: Output
        }], headerClickCallback: [{
            type: Output
        }], amdocsTableHeaderWrapper: [{
            type: ViewChild,
            args: ['amdocsTableHeaderWrapper']
        }], amdocsTableBodyWrapper: [{
            type: ViewChild,
            args: ['amdocsTableBodyWrapper']
        }] }); })();

function AmdocsPopoverComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵprojection(0, 1);
} }
const _c0$e = [[["", "popoverOpener", ""]], [["", "popoverContent", ""]]];
const _c1$a = ["[popoverOpener]", "[popoverContent]"];
/**
 * Rc popover component - render content and open another content in popover on click.
 * Currently uses ngx-bootstrap popover
 *
 * @example
 * <lib-rc-popover [trigger]="click" [placement]="bottom">
 *  <div popoverOpener>I am the opener</div>
 *  <div popoverContent>Some content, can be another component</div>
 * </lib-rc-popover>
 * Example of usage:
 * <example-url>http://documentation.stage-rc.com/demo/?showAll=false&componentName=RcPopoverComponent</example-url>
 */
class AmdocsPopoverComponent {
    constructor() {
        /**
         * Popover trigger
         */
        this.trigger = 'click';
        /**
         * Set if click out side will close the popover
         */
        this.outsideClick = true;
        /**
         * Set popover location (top, bottom, left, right)
         */
        this.placement = 'bottom';
    }
    /**
     * check if popup is open
     * return boolean
     */
    get isOpen() {
        return this.pop && this.pop.isOpen;
    }
    /**
     *hide popup
     * return void
     */
    hide() {
        this.pop.hide();
    }
    /**
     * show popup
     * return void
     */
    open() {
        this.pop.show();
    }
}
AmdocsPopoverComponent.ɵfac = function AmdocsPopoverComponent_Factory(t) { return new (t || AmdocsPopoverComponent)(); };
AmdocsPopoverComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsPopoverComponent, selectors: [["lib-amdocs-popover"]], viewQuery: function AmdocsPopoverComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(PopoverDirective, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.pop = _t.first);
    } }, inputs: { trigger: "trigger", outsideClick: "outsideClick", placement: "placement" }, ngContentSelectors: _c1$a, decls: 5, vars: 6, consts: [["href", "javascript:void(0)", 3, "popover", "triggers", "outsideClick", "placement", "containerClass"], ["pop", "bs-popover"], ["popoverContent", ""]], template: function AmdocsPopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef(_c0$e);
        ɵɵelementStart(0, "a", 0, 1);
        ɵɵprojection(2);
        ɵɵelementEnd();
        ɵɵtemplate(3, AmdocsPopoverComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵɵreference(4);
        ɵɵpropertyInterpolate("triggers", ctx.trigger);
        ɵɵpropertyInterpolate("placement", ctx.placement);
        ɵɵproperty("popover", _r1)("outsideClick", ctx.outsideClick)("containerClass", ctx.placement == "bottom right" ? "bottomRight" : "");
        ɵɵattribute("aria-expanded", ctx.isOpen);
    } }, directives: [PopoverDirective], styles: [".popover{border:none;box-shadow:0 0 35px 0 rgba(0,0,0,.29)}  .popover   .arrow:before{content:none}  .popover.bottomRight{left:55px!important;top:15px!important}  .popover.bottomRight   .arrow{height:17px;margin-left:-55px!important;top:-14px;width:40px}  .popover.bottomRight   .arrow:before{content:none}  .popover.bottomRight   .arrow:after{border-color:transparent transparent #fff;border-width:0 19px 14px}  .popover .popover-content.popover-body{padding:24px;width:266px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPopoverComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-popover',
                templateUrl: './amdocs-popover.component.html',
                styleUrls: ['./amdocs-popover.component.scss']
            }]
    }], function () { return []; }, { trigger: [{
            type: Input
        }], outsideClick: [{
            type: Input
        }], placement: [{
            type: Input
        }], pop: [{
            type: ViewChild,
            args: [PopoverDirective]
        }] }); })();

const _c0$f = ["datepickerComp"];
function AmdocsDatepickerComponent_bs_datepicker_inline_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "bs-datepicker-inline", 4, 5);
    ɵɵlistener("bsValueChange", function AmdocsDatepickerComponent_bs_datepicker_inline_1_Template_bs_datepicker_inline_bsValueChange_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.onDateChange(); })("bsValueChange", function AmdocsDatepickerComponent_bs_datepicker_inline_1_Template_bs_datepicker_inline_bsValueChange_0_listener($event) { ɵɵrestoreView(_r5); const ctx_r6 = ɵɵnextContext(); return ctx_r6.bsInlineValue = $event; });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("bsConfig", ctx_r0.config)("bsValue", ctx_r0.bsInlineValue)("minDate", ctx_r0.minimumDate)("maxDate", ctx_r0.maximumDate);
} }
function AmdocsDatepickerComponent_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "input", 6);
    ɵɵlistener("bsValueChange", function AmdocsDatepickerComponent_input_2_Template_input_bsValueChange_0_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.onDateChange(); })("bsValueChange", function AmdocsDatepickerComponent_input_2_Template_input_bsValueChange_0_listener($event) { ɵɵrestoreView(_r8); const ctx_r9 = ɵɵnextContext(); return ctx_r9.bsInlineValue = $event; });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("id", "datepicker" + ctx_r1.containerId)("container", "#" + ctx_r1.containerId)("placeholder", ctx_r1.placeholder)("bsConfig", ctx_r1.config)("bsValue", ctx_r1.bsInlineValue)("minDate", ctx_r1.minimumDate)("maxDate", ctx_r1.maximumDate)("disabled", ctx_r1.disabled);
} }
function AmdocsDatepickerComponent_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 7);
    ɵɵelement(1, "i", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("for", "datepicker" + ctx_r2.containerId);
} }
class AmdocsDatepickerComponent {
    constructor(timeService, localeService) {
        this.timeService = timeService;
        this.localeService = localeService;
        this.inlineView = false;
        this.withIcon = false;
        this.placeholder = 'Select Date';
        this.disabled = false;
        this.dateChange = new EventEmitter();
        this.containerId = 'datepicker-container-' + Math.floor(Math.random() * 100000);
        this.show = false;
        this.changeCnt = 0;
        this.bsConfig = {
            showWeekNumbers: false,
            customTodayClass: 'today'
        };
        this.currentMonthView = this.timeService.moment(this.initialValue);
        enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
        enGbLocale.week.dow = 0;
        defineLocale('en-gb', enGbLocale);
        this.localeService.use('en-gb');
    }
    set minDate(value) {
        this.minimumDate = new Date(value);
    }
    set maxDate(value) {
        this.maximumDate = new Date(value);
    }
    ngOnInit() {
        this.config = Object.assign({}, this.bsConfig, this.config);
        if (this.initialValue) {
            this.bsInlineValue = this.timeService.moment(this.initialValue).toDate();
        }
    }
    onDateChange() {
        setTimeout(() => {
            this.dateChange.emit(this.timeService.moment(this.bsInlineValue).format('YYYY-MM-DD'));
        });
    }
    next() {
        this.currentMonthView.add('1', 'M');
        document.querySelector('.bs-datepicker-head button.next').click();
    }
    prev() {
        this.currentMonthView.subtract('1', 'M');
        document.querySelector('.bs-datepicker-head button.previous').click();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.show = true;
        });
    }
}
AmdocsDatepickerComponent.ɵfac = function AmdocsDatepickerComponent_Factory(t) { return new (t || AmdocsDatepickerComponent)(ɵɵdirectiveInject(AmdocsTimeService), ɵɵdirectiveInject(BsLocaleService)); };
AmdocsDatepickerComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsDatepickerComponent, selectors: [["lib-amdocs-datepicker"]], viewQuery: function AmdocsDatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$f, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.datepickerComp = _t.first);
    } }, inputs: { config: "config", initialValue: "initialValue", inlineView: "inlineView", withIcon: "withIcon", placeholder: "placeholder", minDate: "minDate", maxDate: "maxDate", disabled: "disabled" }, outputs: { dateChange: "dateChange" }, decls: 4, vars: 4, consts: [[1, "amdocs-date-picker-wrapper", 3, "id"], [3, "bsConfig", "bsValue", "minDate", "maxDate", "bsValueChange", 4, "ngIf"], ["type", "text", "class", "form-control", "bsDatepicker", "", 3, "id", "container", "placeholder", "bsConfig", "bsValue", "minDate", "maxDate", "disabled", "bsValueChange", 4, "ngIf"], ["class", "add-on", 3, "for", 4, "ngIf"], [3, "bsConfig", "bsValue", "minDate", "maxDate", "bsValueChange"], ["datepickerComp", ""], ["type", "text", "bsDatepicker", "", 1, "form-control", 3, "id", "container", "placeholder", "bsConfig", "bsValue", "minDate", "maxDate", "disabled", "bsValueChange"], [1, "add-on", 3, "for"], [1, "calendar-icon"]], template: function AmdocsDatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AmdocsDatepickerComponent_bs_datepicker_inline_1_Template, 2, 4, "bs-datepicker-inline", 1);
        ɵɵtemplate(2, AmdocsDatepickerComponent_input_2_Template, 1, 8, "input", 2);
        ɵɵtemplate(3, AmdocsDatepickerComponent_label_3_Template, 2, 1, "label", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵpropertyInterpolate("id", ctx.containerId);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.inlineView);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show && !ctx.inlineView);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.withIcon);
    } }, directives: [NgIf, BsDatepickerInlineDirective, BsDatepickerInputDirective, BsDatepickerDirective], styles: [".amdocs-date-picker-wrapper[_ngcontent-%COMP%]{position:relative}.amdocs-date-picker-wrapper[_ngcontent-%COMP%]   .calendar-icon[_ngcontent-%COMP%]{background-image:url(/assets/icons/calendar-icon.svg);background-repeat:no-repeat;cursor:pointer;height:23px;position:absolute;right:12px;top:6px;width:23px}.amdocs-date-picker-wrapper[_ngcontent-%COMP%]   input[disabled][_ngcontent-%COMP%]{background-color:#f6e8e8}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsDatepickerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-datepicker',
                templateUrl: './amdocs-datepicker.component.html',
                styleUrls: ['./amdocs-datepicker.component.scss']
            }]
    }], function () { return [{ type: AmdocsTimeService }, { type: BsLocaleService }]; }, { datepickerComp: [{
            type: ViewChild,
            args: ['datepickerComp']
        }], config: [{
            type: Input
        }], initialValue: [{
            type: Input
        }], inlineView: [{
            type: Input
        }], withIcon: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], minDate: [{
            type: Input,
            args: ['minDate']
        }], maxDate: [{
            type: Input,
            args: ['maxDate']
        }], disabled: [{
            type: Input
        }], dateChange: [{
            type: Output
        }] }); })();

class AmdocsToastrComponent {
    constructor(toastr) {
        this.toastr = toastr;
        this.timeOut = 3000;
        this.toasterClose = new EventEmitter();
    }
    ngOnInit() {
        const options = {
            closeButton: true,
            timeOut: this.timeOut,
        };
        if (this.toastType === EToasterType.info) {
            this.toastr.info(this.msg, this.title, options);
        }
        if (this.toastType === EToasterType.success) {
            this.toastr.success(this.msg, this.title, options);
        }
        if (this.toastType === EToasterType.error) {
            this.toastr.error(this.msg, this.title, options);
        }
        if (this.toastType === EToasterType.warning) {
            this.toastr.warning(this.msg, this.title, options);
        }
        setTimeout(() => {
            this.toasterClose.emit();
        }, this.timeOut);
    }
}
AmdocsToastrComponent.ɵfac = function AmdocsToastrComponent_Factory(t) { return new (t || AmdocsToastrComponent)(ɵɵdirectiveInject(ToastrService)); };
AmdocsToastrComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsToastrComponent, selectors: [["lib-amdocs-toastr"]], inputs: { title: "title", msg: "msg", toastType: "toastType", timeOut: "timeOut" }, outputs: { toasterClose: "toasterClose" }, decls: 0, vars: 0, template: function AmdocsToastrComponent_Template(rf, ctx) { }, styles: [".toast-container{left:0;position:fixed;right:0}  .toast-container .ngx-toastr{background-position:24px;border-radius:8px;border-top:4px solid;color:#22212e;padding:20px 24px 20px 60px;width:100%}  .toast-container .ngx-toastr .toast-close-button{position:absolute;right:24px;top:10px}  .toast-container .ngx-toastr .toast-close-button span{color:#666d83;font-size:20px;font-weight:500;line-height:normal}  .toast-container .ngx-toastr .toast-title{font-size:12px;font-weight:600;line-height:15px}  .toast-container .ngx-toastr .toast-message{font-size:12px;line-height:18px;margin-top:7px}  .toast-container .ngx-toastr.toast-info{background-color:#dddefc;border-color:#424484}  .toast-container .ngx-toastr.toast-success{background-color:#cdf4e3;background-image:url(/assets/icons/toaster-success.svg)!important;border-color:#05bf6f}  .toast-container .ngx-toastr.toast-error{background-color:#ffe5eb;border-color:#df1744}  .toast-container .ngx-toastr.toast-warning{background-color:#fff2d5;border-color:#eba606}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsToastrComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-toastr',
                templateUrl: './amdocs-toastr.component.html',
                styleUrls: ['./amdocs-toastr.component.scss']
            }]
    }], function () { return [{ type: ToastrService }]; }, { title: [{
            type: Input
        }], msg: [{
            type: Input
        }], toastType: [{
            type: Input
        }], timeOut: [{
            type: Input
        }], toasterClose: [{
            type: Output
        }] }); })();

const _c0$g = ["accordionBody"];
const _c1$b = ["accordionHeader"];
function AmdocsAccordionComponent_accordion_group_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "accordion-group", 3);
    ɵɵelementStart(1, "button", 4);
    ɵɵelementContainer(2, 5);
    ɵɵelementEnd();
    ɵɵelementContainer(3, 5);
    ɵɵelementEnd();
} if (rf & 2) {
    const accordionTemplate_r1 = ctx.$implicit;
    const panelIndex_r2 = ctx.index;
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("isOpen", panelIndex_r2 == ctx_r0.openPanelNumber);
    ɵɵadvance(2);
    ɵɵproperty("ngTemplateOutlet", ctx_r0.findHeaderTemplate(panelIndex_r2));
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", accordionTemplate_r1);
} }
class AmdocsAccordionComponent {
    constructor() {
        this.isAnimated = true;
        this.openOnlyOne = true;
        this.withCloseOpenIcon = true;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        console.log(this.accordionTemplates);
        console.log(this.accordionTemplatesHeader);
    }
    findHeaderTemplate(index) {
        return this.accordionTemplatesHeader.find((_, i) => i === index);
    }
}
AmdocsAccordionComponent.ɵfac = function AmdocsAccordionComponent_Factory(t) { return new (t || AmdocsAccordionComponent)(); };
AmdocsAccordionComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsAccordionComponent, selectors: [["lib-amdocs-accordion"]], contentQueries: function AmdocsAccordionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, _c0$g, false);
        ɵɵcontentQuery(dirIndex, _c1$b, false);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.accordionTemplates = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.accordionTemplatesHeader = _t);
    } }, inputs: { isAnimated: "isAnimated", openPanelNumber: "openPanelNumber", openOnlyOne: "openOnlyOne", withCloseOpenIcon: "withCloseOpenIcon" }, decls: 3, vars: 5, consts: [[1, "amdocs-accordion-wrapper"], [3, "isAnimated", "closeOthers"], [3, "isOpen", 4, "ngFor", "ngForOf"], [3, "isOpen"], ["accordion-heading", "", "type", "button", 1, "btn", "btn-link", "btn-block", "clearfix"], [3, "ngTemplateOutlet"]], template: function AmdocsAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "accordion", 1);
        ɵɵtemplate(2, AmdocsAccordionComponent_accordion_group_2_Template, 4, 3, "accordion-group", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassProp("with-icon", ctx.withCloseOpenIcon);
        ɵɵadvance(1);
        ɵɵproperty("isAnimated", ctx.isAnimated)("closeOthers", ctx.openOnlyOne);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.accordionTemplates);
    } }, directives: [AccordionComponent, NgForOf, AccordionPanelComponent, NgTemplateOutlet], styles: [".amdocs-accordion-wrapper[_ngcontent-%COMP%]     .panel{background:transparent;border:0}.amdocs-accordion-wrapper[_ngcontent-%COMP%]     .card-header{background:transparent;border-bottom:1px solid #f1f1f4;padding:20px 16px}.amdocs-accordion-wrapper[_ngcontent-%COMP%]     .card-header .btn{color:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;padding:0;text-align:left;text-transform:inherit}.amdocs-accordion-wrapper[_ngcontent-%COMP%]     .card-header .btn:focus{text-decoration:none}.amdocs-accordion-wrapper.with-icon[_ngcontent-%COMP%]     .card-header .accordion-toggle{position:relative}.amdocs-accordion-wrapper.with-icon[_ngcontent-%COMP%]     .card-header .accordion-toggle:after{content:url(/assets/icons/purple-plus-icon.svg);position:absolute;right:0;top:0;transition:all .3s}.amdocs-accordion-wrapper.with-icon[_ngcontent-%COMP%]     .card-header .accordion-toggle[aria-expanded=true]:after{transform:rotate(45deg)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAccordionComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-accordion',
                templateUrl: './amdocs-accordion.component.html',
                styleUrls: ['./amdocs-accordion.component.scss']
            }]
    }], function () { return []; }, { isAnimated: [{
            type: Input
        }], openPanelNumber: [{
            type: Input
        }], openOnlyOne: [{
            type: Input
        }], withCloseOpenIcon: [{
            type: Input
        }], accordionTemplates: [{
            type: ContentChildren,
            args: ['accordionBody']
        }], accordionTemplatesHeader: [{
            type: ContentChildren,
            args: ['accordionHeader']
        }] }); })();

const _c0$h = [[["", "popupHeader", ""]], [["", "popupContent", ""]], [["", "popupFooter", ""]]];
const _c1$c = ["[popupHeader]", "[popupContent]", "[popupFooter]"];
class AmdocsPopupDesktopWrapperComponentComponent {
    constructor() { }
    ngOnInit() {
    }
}
AmdocsPopupDesktopWrapperComponentComponent.ɵfac = function AmdocsPopupDesktopWrapperComponentComponent_Factory(t) { return new (t || AmdocsPopupDesktopWrapperComponentComponent)(); };
AmdocsPopupDesktopWrapperComponentComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsPopupDesktopWrapperComponentComponent, selectors: [["lib-amdocs-popup-desktop-wrapper-component"]], ngContentSelectors: _c1$c, decls: 7, vars: 0, consts: [[1, "desktop-popup-wrapper"], [1, "header-wrapper"], [1, "content-wrapper"], [1, "buttons-wrapper"]], template: function AmdocsPopupDesktopWrapperComponentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef(_c0$h);
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵprojection(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 2);
        ɵɵprojection(4, 1);
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 3);
        ɵɵprojection(6, 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, styles: [".desktop-popup-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]{border-bottom:1px solid #f1f1f4;padding:20px 30px}.desktop-popup-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]:empty{border:none;padding:12px}.desktop-popup-wrapper[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{padding:30px}.desktop-popup-wrapper[_ngcontent-%COMP%]   .buttons-wrapper[_ngcontent-%COMP%]{box-shadow:0 -2px 10px 0 rgba(0,0,0,.07);padding:24px 30px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPopupDesktopWrapperComponentComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-popup-desktop-wrapper-component',
                templateUrl: './amdocs-popup-desktop-wrapper-component.component.html',
                styleUrls: ['./amdocs-popup-desktop-wrapper-component.component.scss']
            }]
    }], function () { return []; }, null); })();

const _c0$i = ["fileInput"];
class AmdocsUploadFileComponent extends AmdocsControlAbstract {
    constructor() {
        super(...arguments);
        this.label = 'Add attachment';
        this.fileTypes = [];
        this.onFileChange = new EventEmitter();
        this.onFileValidationError = new EventEmitter();
    }
    openFileInput() {
        this.fileInput.nativeElement.click();
    }
    handleFileInput(files) {
        console.log('files', files);
        if (files.length) {
            const file = files.item(0);
            if (this.maxSize) {
                if (file.size > (this.maxSize * 1000000)) {
                    return this.handleValidationError(file);
                }
            }
            if (this.fileTypes.length) {
                const parts = file.name.split('.');
                const ext = parts[parts.length - 1];
                if (this.fileTypes.indexOf(ext.toLowerCase()) === -1) {
                    return this.handleValidationError(file);
                }
            }
            this.readFile(file).subscribe((base64File) => {
                this.onFileChange.emit({ file: file, base64File: base64File });
            });
        }
    }
    handleValidationError(file) {
        this.control.setValue(null);
        this.onFileValidationError.emit(file);
    }
    readFile(fileToRead) {
        const base64Observable = new ReplaySubject();
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
            base64Observable.next(fileReader.result);
        };
        fileReader.readAsDataURL(fileToRead);
        return base64Observable;
    }
}
AmdocsUploadFileComponent.ɵfac = function AmdocsUploadFileComponent_Factory(t) { return ɵAmdocsUploadFileComponent_BaseFactory(t || AmdocsUploadFileComponent); };
AmdocsUploadFileComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsUploadFileComponent, selectors: [["lib-amdocs-upload-file"]], viewQuery: function AmdocsUploadFileComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$i, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { label: "label", maxSize: "maxSize", fileTypes: "fileTypes", accept: "accept" }, outputs: { onFileChange: "onFileChange", onFileValidationError: "onFileValidationError" }, features: [ɵɵInheritDefinitionFeature], decls: 7, vars: 4, consts: [[1, "amdocs-upload-file-wrapper"], [1, "amdocs-upload-file", 3, "click"], ["image-src", "", "src", "/assets/icons/add.svg", 1, "image"], [1, "text-small-normal", "label"], ["type", "file", "readonly", "", 1, "form-control", 2, "display", "none", 3, "id", "formControl", "focus", "blur", "change"], ["fileInput", ""]], template: function AmdocsUploadFileComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "button", 1);
        ɵɵlistener("click", function AmdocsUploadFileComponent_Template_button_click_1_listener() { ɵɵrestoreView(_r1); const _r0 = ɵɵreference(6); return _r0.click(); });
        ɵɵelement(2, "img", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "input", 4, 5);
        ɵɵlistener("focus", function AmdocsUploadFileComponent_Template_input_focus_5_listener() { return ctx.onFocus(); })("blur", function AmdocsUploadFileComponent_Template_input_blur_5_listener($event) { return ctx.onBlur($event); })("change", function AmdocsUploadFileComponent_Template_input_change_5_listener($event) { return ctx.handleFileInput($event.target.files); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵtextInterpolate(ctx.label);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("id", ctx.elementId);
        ɵɵproperty("formControl", ctx.control);
        ɵɵattribute("accept", ctx.accept);
    } }, directives: [DefaultValueAccessor, NgControlStatus, FormControlDirective], styles: [".amdocs-upload-file-wrapper[_ngcontent-%COMP%]   .amdocs-upload-file[_ngcontent-%COMP%]{align-items:center;background:transparent;border:transparent;color:#22212e;display:flex}.amdocs-upload-file-wrapper[_ngcontent-%COMP%]   .amdocs-upload-file[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-left:8px}"] });
const ɵAmdocsUploadFileComponent_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(AmdocsUploadFileComponent);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsUploadFileComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-upload-file',
                templateUrl: './amdocs-upload-file.component.html',
                styleUrls: ['./amdocs-upload-file.component.scss']
            }]
    }], null, { fileInput: [{
            type: ViewChild,
            args: ['fileInput', { static: true }]
        }], label: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], fileTypes: [{
            type: Input
        }], accept: [{
            type: Input
        }], onFileChange: [{
            type: Output
        }], onFileValidationError: [{
            type: Output
        }] }); })();

const _c0$j = function (a0) { return { "disable": a0 }; };
function AmdocsPaginatorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "div", 3);
    ɵɵelementStart(3, "input", 4);
    ɵɵlistener("focus", function AmdocsPaginatorComponent_div_0_Template_input_focus_3_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.onFocus(); })("blur", function AmdocsPaginatorComponent_div_0_Template_input_blur_3_listener() { ɵɵrestoreView(_r2); const ctx_r3 = ɵɵnextContext(); return ctx_r3.onBlur(); })("input", function AmdocsPaginatorComponent_div_0_Template_input_input_3_listener($event) { ɵɵrestoreView(_r2); const ctx_r4 = ɵɵnextContext(); return ctx_r4.valueChange($event); })("ngModelChange", function AmdocsPaginatorComponent_div_0_Template_input_ngModelChange_3_listener($event) { ɵɵrestoreView(_r2); const ctx_r5 = ɵɵnextContext(); return ctx_r5.pageNumber = $event; });
    ɵɵelementEnd();
    ɵɵelementStart(4, "span", 5);
    ɵɵtext(5, "/ ");
    ɵɵelementEnd();
    ɵɵelementStart(6, "span", 6);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", 7);
    ɵɵelementStart(9, "div", 8);
    ɵɵlistener("click", function AmdocsPaginatorComponent_div_0_Template_div_click_9_listener() { ɵɵrestoreView(_r2); const ctx_r6 = ɵɵnextContext(); return ctx_r6.prev(); });
    ɵɵelement(10, "div", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "div", 7);
    ɵɵelementStart(12, "div", 10);
    ɵɵlistener("click", function AmdocsPaginatorComponent_div_0_Template_div_click_12_listener() { ɵɵrestoreView(_r2); const ctx_r7 = ɵɵnextContext(); return ctx_r7.next(); });
    ɵɵelement(13, "div", 11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("min", 1)("max", ctx_r0.lastPage)("ngModel", ctx_r0.pageNumber);
    ɵɵadvance(4);
    ɵɵtextInterpolate(ctx_r0.lastPage);
    ɵɵadvance(2);
    ɵɵproperty("disabled", !ctx_r0.allowPrev);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(8, _c0$j, ctx_r0.pageNumber === 1));
    ɵɵadvance(2);
    ɵɵproperty("disabled", !ctx_r0.allowNext);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c0$j, ctx_r0.pageNumber === ctx_r0.lastPage));
} }
class AmdocsPaginatorComponent {
    constructor() {
        this.pageSize = 10;
        this.pageNumber = 1;
        this.totalRows = 0;
        this.onPageChange = new EventEmitter();
    }
    ngOnInit() {
        this.origValue = this.pageNumber;
    }
    get allowNext() {
        return this.pageNumber < this.lastPage;
    }
    get allowPrev() {
        return this.pageNumber > 1;
    }
    get lastPage() {
        return Math.ceil(this.totalRows / this.pageSize);
    }
    next() {
        if (this.allowNext) {
            this.pageNumber++;
            this.pageChange();
        }
    }
    prev() {
        if (this.allowPrev) {
            this.pageNumber--;
            this.pageChange();
        }
    }
    valueChange($event) {
        this.pageNumber = $event.target.value ? parseInt($event.target.value, 10) : null;
        setTimeout(() => {
            if (this.pageNumber) {
                if (this.pageNumber > this.lastPage) {
                    this.pageNumber = this.lastPage;
                }
                else if (this.pageNumber < 1) {
                    this.pageNumber = 1;
                }
            }
        }, 0);
    }
    onBlur() {
        if (!this.pageNumber) {
            this.pageNumber = this.origValue;
        }
        if (this.origValue !== this.pageNumber) {
            this.pageChange();
        }
    }
    onFocus() {
        this.origValue = this.pageNumber;
    }
    pageChange() {
        this.onPageChange.emit(this.pageNumber);
    }
}
AmdocsPaginatorComponent.ɵfac = function AmdocsPaginatorComponent_Factory(t) { return new (t || AmdocsPaginatorComponent)(); };
AmdocsPaginatorComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsPaginatorComponent, selectors: [["lib-amdocs-paginator"]], inputs: { pageSize: "pageSize", pageNumber: "pageNumber", totalRows: "totalRows" }, outputs: { onPageChange: "onPageChange" }, decls: 1, vars: 1, consts: [["class", "paginator d-flex", 4, "ngIf"], [1, "paginator", "d-flex"], [1, "d-flex"], [1, "current-page-wrapper"], ["type", "number", 1, "current-page", "text-small-bold", 3, "min", "max", "ngModel", "focus", "blur", "input", "ngModelChange"], [1, "text-small-normal", "gray"], [1, "last-page", "text-small-normal", "gray"], [1, "next-prev-wrapper", "d-flex", "align-items-center"], ["href", "javascript:void(0)", 1, "prev", 3, "disabled", "click"], [1, "icon", "icon-right", 3, "ngClass"], ["href", "javascript:void(0)", 1, "next", 3, "disabled", "click"], [1, "icon", "icon-left", 3, "ngClass"]], template: function AmdocsPaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AmdocsPaginatorComponent_div_0_Template, 14, 12, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.lastPage);
    } }, directives: [NgIf, NumberValueAccessor, DefaultValueAccessor, NgControlStatus, NgModel, NgClass], styles: [".paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]{color:#343647;margin:0;padding:0 5px}.paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]   input.current-page[_ngcontent-%COMP%]{background:transparent;border:none;border-bottom:1px solid #a3a3ae;display:inline-block;text-align:center;width:27px}.paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]   input.last-page[_ngcontent-%COMP%]{display:inline-block;text-align:center}.paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}.paginator[_ngcontent-%COMP%]   .current-page-wrapper[_ngcontent-%COMP%]   .gray[_ngcontent-%COMP%]{color:#a3a3ae}.paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%], .paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .prev[_ngcontent-%COMP%]{background:none;border:none;cursor:pointer}.paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .prev[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{background-color:transparent;background-image:url(/assets/icons/pagination-arrow.svg);background-position:50%;background-repeat:no-repeat;height:19px;margin-left:5px;width:10px}.paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%]   .icon.icon-right[_ngcontent-%COMP%], .paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .prev[_ngcontent-%COMP%]   .icon.icon-right[_ngcontent-%COMP%]{transform:rotate(180deg);transform-origin:center center}.paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%]   .icon.disable[_ngcontent-%COMP%], .paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .prev[_ngcontent-%COMP%]   .icon.disable[_ngcontent-%COMP%]{background-image:url(/assets/icons/pagination-arrow-disable.svg);transform:rotate(180deg)}.paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .next[_ngcontent-%COMP%]   .icon.disable.icon-right[_ngcontent-%COMP%], .paginator[_ngcontent-%COMP%]   .next-prev-wrapper[_ngcontent-%COMP%]   .prev[_ngcontent-%COMP%]   .icon.disable.icon-right[_ngcontent-%COMP%]{transform:rotate(0deg);transform-origin:center center}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsPaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-paginator',
                templateUrl: './amdocs-paginator.component.html',
                styleUrls: ['./amdocs-paginator.component.scss']
            }]
    }], function () { return []; }, { pageSize: [{
            type: Input
        }], pageNumber: [{
            type: Input
        }], totalRows: [{
            type: Input
        }], onPageChange: [{
            type: Output
        }] }); })();

/**
 * @description
 * Amdocs amdocs-image-version directive - add version to source image
 *
 * @example
 * <img amdocs-image-version >Some content</div>
 *
 */
class AmdocsImageVersionDirective {
    constructor(el, imageVersion) {
        this.el = el;
        this.imageVersion = imageVersion;
    }
    ngAfterContentInit() {
        this.el.nativeElement.src = `${this.el.nativeElement.src}?${this.imageVersion}`;
    }
}
AmdocsImageVersionDirective.ɵfac = function AmdocsImageVersionDirective_Factory(t) { return new (t || AmdocsImageVersionDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject('IImageVersion')); };
AmdocsImageVersionDirective.ɵdir = ɵɵdefineDirective({ type: AmdocsImageVersionDirective, selectors: [["", "lib-amdocs-image-version", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsImageVersionDirective, [{
        type: Directive,
        args: [{
                selector: '[lib-amdocs-image-version]'
            }]
    }], function () { return [{ type: ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: ['IImageVersion']
            }] }]; }, null); })();

const components = [
    AmdocsAppErrorComponent,
    AmdocsCheckboxComponent,
    AmdocsDropdownComponent,
    AmdocsRadioComponent,
    AmdocsMimicComponent,
    AmdocsPopupComponent,
    AmdocsSwitcherComponent,
    AmdocsTopHeaderComponent,
    AmdocsTranslatePipe,
    AmdocsTruncatePipe,
    AmdocsDynamicPipe,
    AmdocsTimeColonFormatPipe,
    AmdocsPopupMessageComponent,
    AmdocsInputFieldComponent,
    AmdocsLargeTextInputComponent,
    AmdocsAppLoaderComponent,
    AmdocsSwiperComponent,
    AmdocsClickOutsideDirective,
    AmdocsImageFallbackDirective,
    AmdocsUserNotifyAlertComponent,
    AmdocsLandscapeViewComponent,
    AmdocsPwaIosNotificationComponent,
    AmdocsVersionUpdateComponent,
    AmdocsDatePipe,
    AmdocsSafeUrlPipe,
    AmdocsStrongSpanPipe,
    AmdocsAutocompleteComponent,
    AmdocsTableComponent,
    AmdocsTableHeaderComponent,
    AmdocsTableRowComponent,
    AmdocsTableCellComponent,
    AmdocsTableDrawerComponent,
    AmdocsPopoverComponent,
    AmdocsDatepickerComponent,
    AmdocsToastrComponent,
    AmdocsAccordionComponent,
    AmdocsPopupDesktopWrapperComponentComponent,
    AmdocsUploadFileComponent,
    AmdocsPaginatorComponent,
    AmdocsImageVersionDirective
];
class AmdocsUiModule {
}
AmdocsUiModule.ɵmod = ɵɵdefineNgModule({ type: AmdocsUiModule });
AmdocsUiModule.ɵinj = ɵɵdefineInjector({ factory: function AmdocsUiModule_Factory(t) { return new (t || AmdocsUiModule)(); }, providers: [], imports: [[
            BsDropdownModule.forRoot(),
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            HttpClientModule,
            ModalModule.forRoot(),
            PopoverModule.forRoot(),
            SwiperModule,
            NgSelectModule,
            NgOptionHighlightModule,
            BsDatepickerModule.forRoot(),
            AccordionModule.forRoot()
            // TooltipModule.forRoot()
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AmdocsUiModule, { declarations: [AmdocsAppErrorComponent,
        AmdocsCheckboxComponent,
        AmdocsDropdownComponent,
        AmdocsRadioComponent,
        AmdocsMimicComponent,
        AmdocsPopupComponent,
        AmdocsSwitcherComponent,
        AmdocsTopHeaderComponent,
        AmdocsTranslatePipe,
        AmdocsTruncatePipe,
        AmdocsDynamicPipe,
        AmdocsTimeColonFormatPipe,
        AmdocsPopupMessageComponent,
        AmdocsInputFieldComponent,
        AmdocsLargeTextInputComponent,
        AmdocsAppLoaderComponent,
        AmdocsSwiperComponent,
        AmdocsClickOutsideDirective,
        AmdocsImageFallbackDirective,
        AmdocsUserNotifyAlertComponent,
        AmdocsLandscapeViewComponent,
        AmdocsPwaIosNotificationComponent,
        AmdocsVersionUpdateComponent,
        AmdocsDatePipe,
        AmdocsSafeUrlPipe,
        AmdocsStrongSpanPipe,
        AmdocsAutocompleteComponent,
        AmdocsTableComponent,
        AmdocsTableHeaderComponent,
        AmdocsTableRowComponent,
        AmdocsTableCellComponent,
        AmdocsTableDrawerComponent,
        AmdocsPopoverComponent,
        AmdocsDatepickerComponent,
        AmdocsToastrComponent,
        AmdocsAccordionComponent,
        AmdocsPopupDesktopWrapperComponentComponent,
        AmdocsUploadFileComponent,
        AmdocsPaginatorComponent,
        AmdocsImageVersionDirective], imports: [BsDropdownModule, CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule, ModalModule, PopoverModule, SwiperModule,
        NgSelectModule,
        NgOptionHighlightModule, BsDatepickerModule, AccordionModule], exports: [AmdocsAppErrorComponent,
        AmdocsCheckboxComponent,
        AmdocsDropdownComponent,
        AmdocsRadioComponent,
        AmdocsMimicComponent,
        AmdocsPopupComponent,
        AmdocsSwitcherComponent,
        AmdocsTopHeaderComponent,
        AmdocsTranslatePipe,
        AmdocsTruncatePipe,
        AmdocsDynamicPipe,
        AmdocsTimeColonFormatPipe,
        AmdocsPopupMessageComponent,
        AmdocsInputFieldComponent,
        AmdocsLargeTextInputComponent,
        AmdocsAppLoaderComponent,
        AmdocsSwiperComponent,
        AmdocsClickOutsideDirective,
        AmdocsImageFallbackDirective,
        AmdocsUserNotifyAlertComponent,
        AmdocsLandscapeViewComponent,
        AmdocsPwaIosNotificationComponent,
        AmdocsVersionUpdateComponent,
        AmdocsDatePipe,
        AmdocsSafeUrlPipe,
        AmdocsStrongSpanPipe,
        AmdocsAutocompleteComponent,
        AmdocsTableComponent,
        AmdocsTableHeaderComponent,
        AmdocsTableRowComponent,
        AmdocsTableCellComponent,
        AmdocsTableDrawerComponent,
        AmdocsPopoverComponent,
        AmdocsDatepickerComponent,
        AmdocsToastrComponent,
        AmdocsAccordionComponent,
        AmdocsPopupDesktopWrapperComponentComponent,
        AmdocsUploadFileComponent,
        AmdocsPaginatorComponent,
        AmdocsImageVersionDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsUiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BsDropdownModule.forRoot(),
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    ModalModule.forRoot(),
                    PopoverModule.forRoot(),
                    SwiperModule,
                    NgSelectModule,
                    NgOptionHighlightModule,
                    BsDatepickerModule.forRoot(),
                    AccordionModule.forRoot()
                    // TooltipModule.forRoot()
                ],
                providers: [],
                declarations: [...components],
                exports: [...components]
            }]
    }], null, null); })();

class AmdocsAppPreloadingStrategy {
    preload(route, load) {
        const loadRoute = (delay) => delay
            ? timer(150).pipe(map(_ => load()))
            : load();
        return route.data && route.data.preload
            ? loadRoute(route.data.delay)
            : of(null);
    }
}
AmdocsAppPreloadingStrategy.ɵfac = function AmdocsAppPreloadingStrategy_Factory(t) { return new (t || AmdocsAppPreloadingStrategy)(); };
AmdocsAppPreloadingStrategy.ɵprov = ɵɵdefineInjectable({ token: AmdocsAppPreloadingStrategy, factory: AmdocsAppPreloadingStrategy.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsAppPreloadingStrategy, [{
        type: Injectable
    }], null, null); })();

class AmdocsUtilsModule {
}
AmdocsUtilsModule.ɵmod = ɵɵdefineNgModule({ type: AmdocsUtilsModule });
AmdocsUtilsModule.ɵinj = ɵɵdefineInjector({ factory: function AmdocsUtilsModule_Factory(t) { return new (t || AmdocsUtilsModule)(); }, providers: [
        AmdocsApiUtilsService,
        AmdocsApiService,
        AmdocsAppPreloadingStrategy,
        AmdocsAppsyncClientService,
        AmdocsAuthService,
        AmdocsEventBusService,
        AmdocsFunctionsService,
        AmdocsGatewayClientService,
        AmdocsTranslateService,
        AmdocsCookieService,
        AmdocsTimeService,
        AmdocsAppInitService,
        AmdocsUserService,
        AmdocsDeviceService,
        AmdocsPwaService,
        CookieService
    ], imports: [[
            HttpClientModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AmdocsUtilsModule, { imports: [HttpClientModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsUtilsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                providers: [
                    AmdocsApiUtilsService,
                    AmdocsApiService,
                    AmdocsAppPreloadingStrategy,
                    AmdocsAppsyncClientService,
                    AmdocsAuthService,
                    AmdocsEventBusService,
                    AmdocsFunctionsService,
                    AmdocsGatewayClientService,
                    AmdocsTranslateService,
                    AmdocsCookieService,
                    AmdocsTimeService,
                    AmdocsAppInitService,
                    AmdocsUserService,
                    AmdocsDeviceService,
                    AmdocsPwaService,
                    CookieService
                ],
                declarations: []
            }]
    }], null, null); })();

// @dynamic
class AmdocsValidatorsClass extends Validators {
    constructor() {
        super(...arguments);
        this.patterns = {
            EMAIL: /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
            ONLY_NUMBERS: /^\d+$/,
            ID_NUMBER: '^[0-9]+$',
        };
    }
    static validateCharacters(validCharacters) {
        return (control) => {
            if (control.value && control.value.length > 0) {
                const matches = control.value.match(validCharacters);
                const empty = control.value.trim().length === 0;
                return !empty && matches && matches.length ? null : { invalidCharacters: true };
            }
            else {
                return null;
            }
        };
    }
    static validateIdNumber() {
        return (control) => {
            if (control.value && control.value.length > 0) {
                let id = String(control.value).trim();
                if (id.length > 9 || id.length < 5) {
                    return false;
                }
                // Pad string with zeros up to 9 digits
                id = id.length < 9 ? ('00000000' + id).slice(-9) : id;
                return Array.from(id, Number).reduce((counter, digit, i) => {
                    const step = digit * ((i % 2) + 1);
                    return counter + (step > 9 ? step - 9 : step);
                }) % 10 === 0 ? null : { invalidCharacters: true };
            }
            else {
                return null;
            }
        };
    }
    static minLength(length) {
        return (control) => {
            if (control.value) {
                return control.value.toString().length >= length ? null : { minlength: true };
            }
            else {
                return null;
            }
        };
    }
    static maxLength(length) {
        return (control) => {
            if (control.value) {
                return control.value.toString().length <= length ? null : { maxlength: true };
            }
            else {
                return null;
            }
        };
    }
    static maxValue(value) {
        return (control) => {
            if (control.value !== null) {
                return control.value <= value ? null : { maxvalue: true };
            }
            else {
                return null;
            }
        };
    }
    static minValue(value) {
        return (control) => {
            if (control.value !== null) {
                return control.value >= value ? null : { minvalue: true };
            }
            else {
                return null;
            }
        };
    }
    static matchPassword(compareControl) {
        return (control) => {
            const value = compareControl.value;
            if (control.value && value !== null) {
                return control.value.toString() === value.toString() ? null : { matchPassword: true };
            }
            else {
                return null;
            }
        };
    }
    static unMatchValue(compareControl) {
        return (control) => {
            const value = compareControl.value;
            if (control.value && value !== null) {
                return control.value.toString() !== value.toString() ? null : { unMatchValue: true };
            }
            else {
                return null;
            }
        };
    }
}

class AmdocsTooltipComponent {
    constructor() { }
    ngOnInit() {
    }
}
AmdocsTooltipComponent.ɵfac = function AmdocsTooltipComponent_Factory(t) { return new (t || AmdocsTooltipComponent)(); };
AmdocsTooltipComponent.ɵcmp = ɵɵdefineComponent({ type: AmdocsTooltipComponent, selectors: [["lib-amdocs-tooltip"]], decls: 2, vars: 0, template: function AmdocsTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, "amdocs-tooltip works! under construction");
        ɵɵelementEnd();
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AmdocsTooltipComponent, [{
        type: Component,
        args: [{
                selector: 'lib-amdocs-tooltip',
                templateUrl: './amdocs-tooltip.component.html',
                styleUrls: ['./amdocs-tooltip.component.scss']
            }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of amdocs-core-package
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AMDOCS_CONSTANTS, AmdocsAccordionComponent, AmdocsApiService, AmdocsApiUtilsService, AmdocsAppErrorComponent, AmdocsAppInitResponse, AmdocsAppInitService, AmdocsAppLoaderComponent, AmdocsAppPreloadingStrategy, AmdocsAppsyncClientService, AmdocsAuthService, AmdocsAutocompleteComponent, AmdocsCheckboxComponent, AmdocsClickOutsideDirective, AmdocsCookieService, AmdocsDatePipe, AmdocsDatepickerComponent, AmdocsDeviceService, AmdocsDropdownComponent, AmdocsDynamicPipe, AmdocsEventBusService, AmdocsFunctionsService, AmdocsGatewayClientService, AmdocsImageFallbackDirective, AmdocsImageVersionDirective, AmdocsInputFieldComponent, AmdocsLandscapeViewComponent, AmdocsLargeTextInputComponent, AmdocsMimicComponent, AmdocsPaginatorComponent, AmdocsPopoverComponent, AmdocsPopupComponent, AmdocsPopupDesktopWrapperComponentComponent, AmdocsPopupMessageComponent, AmdocsPwaIosNotificationComponent, AmdocsPwaService, AmdocsRadioComponent, AmdocsSafeUrlPipe, AmdocsStrongSpanPipe, AmdocsSwiperComponent, AmdocsSwitcherComponent, AmdocsTableCellComponent, AmdocsTableComponent, AmdocsTableDrawerComponent, AmdocsTableHeaderComponent, AmdocsTableRowComponent, AmdocsTimeColonFormatPipe, AmdocsTimeService, AmdocsToastrComponent, AmdocsTooltipComponent, AmdocsTopHeaderComponent, AmdocsTranslatePipe, AmdocsTranslateService, AmdocsTruncatePipe, AmdocsUiModule, AmdocsUploadFileComponent, AmdocsUserNotifyAlertComponent, AmdocsUserService, AmdocsUtilsModule, AmdocsValidatorsClass, AmdocsVersionUpdateComponent, ApiError, DropdownItem, EToasterType, IAutocompleteItem, LANGUAGE };
//# sourceMappingURL=amdocs-core-package.js.map
